module.exports={
    "candidates": [
        {
            "name": "Sarah Mccann",
            "city": 1,
            "color": "orange",
            "qualifications": [
                2,
                1,
                0,
                1
            ]
        },
        {
            "name": "Steven Tucker",
            "city": 0,
            "color": "blue",
            "qualifications": [
                4,
                0,
                2,
                3
            ]
        },
        {
            "name": "Christopher Townsend",
            "city": 0,
            "color": "blue",
            "qualifications": [
                5,
                7,
                1,
                6
            ]
        },
        {
            "name": "Brittany Williams",
            "city": 1,
            "color": "orange",
            "qualifications": [
                2,
                6,
                6,
                8
            ]
        },
        {
            "name": "Loretta Holmes",
            "city": 0,
            "color": "blue",
            "qualifications": [
                5,
                3,
                3,
                0
            ]
        },
        {
            "name": "Shawn Lee",
            "city": 1,
            "color": "orange",
            "qualifications": [
                5,
                6,
                9,
                8
            ]
        },
        {
            "name": "Robert Khan",
            "city": 1,
            "color": "orange",
            "qualifications": [
                7,
                7,
                0,
                2
            ]
        },
        {
            "name": "Larry Lopez",
            "city": 1,
            "color": "orange",
            "qualifications": [
                7,
                2,
                9,
                0
            ]
        },
        {
            "name": "Thomas Austin",
            "city": 0,
            "color": "blue",
            "qualifications": [
                0,
                1,
                4,
                6
            ]
        },
        {
            "name": "Justin Rivera",
            "city": 0,
            "color": "blue",
            "qualifications": [
                8,
                8,
                9,
                7
            ]
        },
        {
            "name": "Adam Wu Jr.",
            "city": 0,
            "color": "blue",
            "qualifications": [
                0,
                2,
                1,
                9
            ]
        },
        {
            "name": "Wayne Stokes",
            "city": 1,
            "color": "orange",
            "qualifications": [
                2,
                9,
                3,
                4
            ]
        },
        {
            "name": "Carlos Brown",
            "city": 1,
            "color": "orange",
            "qualifications": [
                4,
                7,
                2,
                6
            ]
        },
        {
            "name": "Bonnie Palmer",
            "city": 1,
            "color": "orange",
            "qualifications": [
                5,
                7,
                0,
                5
            ]
        },
        {
            "name": "Amanda Brooks",
            "city": 0,
            "color": "blue",
            "qualifications": [
                7,
                4,
                0,
                5
            ]
        },
        {
            "name": "Lisa Jones",
            "city": 1,
            "color": "orange",
            "qualifications": [
                7,
                5,
                6,
                1
            ]
        },
        {
            "name": "Carl English",
            "city": 0,
            "color": "blue",
            "qualifications": [
                3,
                1,
                4,
                4
            ]
        },
        {
            "name": "Brittany Smith",
            "city": 0,
            "color": "blue",
            "qualifications": [
                2,
                4,
                0,
                8
            ]
        },
        {
            "name": "Wendy Vasquez",
            "city": 1,
            "color": "orange",
            "qualifications": [
                0,
                4,
                3,
                4
            ]
        },
        {
            "name": "Justin Miranda",
            "city": 0,
            "color": "blue",
            "qualifications": [
                2,
                6,
                1,
                7
            ]
        },
        {
            "name": "Christopher Lewis",
            "city": 1,
            "color": "orange",
            "qualifications": [
                4,
                1,
                4,
                9
            ]
        },
        {
            "name": "Nicole Davis",
            "city": 1,
            "color": "orange",
            "qualifications": [
                8,
                5,
                8,
                7
            ]
        },
        {
            "name": "James Hanna",
            "city": 0,
            "color": "blue",
            "qualifications": [
                9,
                7,
                0,
                6
            ]
        },
        {
            "name": "George Park",
            "city": 1,
            "color": "orange",
            "qualifications": [
                2,
                6,
                3,
                4
            ]
        },
        {
            "name": "Grant Lawrence",
            "city": 0,
            "color": "blue",
            "qualifications": [
                3,
                6,
                5,
                5
            ]
        },
        {
            "name": "Shawn Morales",
            "city": 1,
            "color": "orange",
            "qualifications": [
                7,
                3,
                3,
                2
            ]
        },
        {
            "name": "Michael Carter",
            "city": 0,
            "color": "blue",
            "qualifications": [
                6,
                2,
                4,
                0
            ]
        },
        {
            "name": "Kristy Olsen",
            "city": 0,
            "color": "blue",
            "qualifications": [
                1,
                4,
                7,
                3
            ]
        },
        {
            "name": "William Jenkins",
            "city": 1,
            "color": "orange",
            "qualifications": [
                0,
                0,
                8,
                0
            ]
        },
        {
            "name": "Charles Stewart",
            "city": 1,
            "color": "orange",
            "qualifications": [
                6,
                8,
                5,
                8
            ]
        },
        {
            "name": "Christopher Decker",
            "city": 0,
            "color": "blue",
            "qualifications": [
                5,
                8,
                0,
                1
            ]
        },
        {
            "name": "Janice Pierce",
            "city": 0,
            "color": "blue",
            "qualifications": [
                3,
                7,
                5,
                5
            ]
        },
        {
            "name": "Robert Day",
            "city": 1,
            "color": "orange",
            "qualifications": [
                0,
                6,
                8,
                7
            ]
        },
        {
            "name": "Amanda Baxter",
            "city": 0,
            "color": "blue",
            "qualifications": [
                4,
                1,
                4,
                9
            ]
        },
        {
            "name": "Mrs. Emily Patel",
            "city": 0,
            "color": "blue",
            "qualifications": [
                6,
                9,
                4,
                8
            ]
        },
        {
            "name": "Shawn Norris",
            "city": 0,
            "color": "orange",
            "qualifications": [
                3,
                9,
                7,
                0
            ]
        },
        {
            "name": "Joseph Serrano",
            "city": 1,
            "color": "orange",
            "qualifications": [
                1,
                0,
                1,
                6
            ]
        },
        {
            "name": "Sherry Mcdonald",
            "city": 1,
            "color": "orange",
            "qualifications": [
                3,
                0,
                9,
                7
            ]
        },
        {
            "name": "Benjamin Bryan",
            "city": 0,
            "color": "blue",
            "qualifications": [
                4,
                4,
                6,
                6
            ]
        },
        {
            "name": "Briana Guerra",
            "city": 1,
            "color": "orange",
            "qualifications": [
                8,
                1,
                3,
                8
            ]
        },
        {
            "name": "Robert Berger",
            "city": 0,
            "color": "blue",
            "qualifications": [
                8,
                7,
                6,
                2
            ]
        },
        {
            "name": "Gary Buchanan",
            "city": 1,
            "color": "orange",
            "qualifications": [
                1,
                7,
                1,
                1
            ]
        },
        {
            "name": "Courtney Wood",
            "city": 0,
            "color": "blue",
            "qualifications": [
                9,
                6,
                2,
                2
            ]
        },
        {
            "name": "Aaron Williams",
            "city": 0,
            "color": "blue",
            "qualifications": [
                4,
                0,
                0,
                7
            ]
        },
        {
            "name": "Alan Proctor",
            "city": 0,
            "color": "blue",
            "qualifications": [
                8,
                3,
                2,
                1
            ]
        },
        {
            "name": "Nicholas Koch",
            "city": 0,
            "color": "blue",
            "qualifications": [
                1,
                8,
                7,
                8
            ]
        },
        {
            "name": "Victor Vargas",
            "city": 1,
            "color": "orange",
            "qualifications": [
                6,
                5,
                0,
                3
            ]
        },
        {
            "name": "Leslie Watson",
            "city": 1,
            "color": "orange",
            "qualifications": [
                7,
                1,
                9,
                8
            ]
        },
        {
            "name": "Jorge Mendoza",
            "city": 1,
            "color": "orange",
            "qualifications": [
                0,
                7,
                8,
                3
            ]
        },
        {
            "name": "Deanna Wagner",
            "city": 0,
            "color": "blue",
            "qualifications": [
                5,
                4,
                4,
                2
            ]
        },
        {
            "name": "Dustin Goodman",
            "city": 1,
            "color": "orange",
            "qualifications": [
                6,
                9,
                4,
                7
            ]
        },
        {
            "name": "Carrie Eaton",
            "city": 1,
            "color": "orange",
            "qualifications": [
                4,
                9,
                8,
                2
            ]
        },
        {
            "name": "Rachel Perez",
            "city": 0,
            "color": "blue",
            "qualifications": [
                2,
                6,
                4,
                1
            ]
        },
        {
            "name": "Rebecca Silva",
            "city": 1,
            "color": "orange",
            "qualifications": [
                2,
                3,
                0,
                4
            ]
        },
        {
            "name": "Jonathan Chase",
            "city": 0,
            "color": "blue",
            "qualifications": [
                7,
                6,
                1,
                4
            ]
        },
        {
            "name": "Brittney Garcia",
            "city": 0,
            "color": "blue",
            "qualifications": [
                6,
                7,
                1,
                9
            ]
        },
        {
            "name": "Jessica Davidson",
            "city": 0,
            "color": "blue",
            "qualifications": [
                9,
                0,
                9,
                7
            ]
        },
        {
            "name": "David Holt",
            "city": 0,
            "color": "blue",
            "qualifications": [
                1,
                2,
                9,
                4
            ]
        },
        {
            "name": "Carrie Barton",
            "city": 0,
            "color": "blue",
            "qualifications": [
                0,
                5,
                5,
                6
            ]
        },
        {
            "name": "Christopher Hall",
            "city": 1,
            "color": "orange",
            "qualifications": [
                0,
                3,
                2,
                2
            ]
        },
        {
            "name": "Lisa Evans",
            "city": 1,
            "color": "orange",
            "qualifications": [
                9,
                7,
                7,
                9
            ]
        },
        {
            "name": "Anthony Hernandez",
            "city": 1,
            "color": "orange",
            "qualifications": [
                5,
                2,
                9,
                3
            ]
        },
        {
            "name": "Kathleen Stanley",
            "city": 1,
            "color": "orange",
            "qualifications": [
                9,
                5,
                1,
                9
            ]
        },
        {
            "name": "Mr. Russell Little",
            "city": 1,
            "color": "orange",
            "qualifications": [
                2,
                9,
                6,
                7
            ]
        },
        {
            "name": "Vincent West",
            "city": 1,
            "color": "orange",
            "qualifications": [
                5,
                1,
                5,
                9
            ]
        },
        {
            "name": "Taylor Brown",
            "city": 0,
            "color": "blue",
            "qualifications": [
                3,
                3,
                2,
                1
            ]
        },
        {
            "name": "Cameron Bryan DDS",
            "city": 0,
            "color": "blue",
            "qualifications": [
                6,
                4,
                8,
                6
            ]
        },
        {
            "name": "Michelle Sutton",
            "city": 0,
            "color": "blue",
            "qualifications": [
                7,
                1,
                7,
                6
            ]
        },
        {
            "name": "Daniel Mathis",
            "city": 0,
            "color": "blue",
            "qualifications": [
                7,
                3,
                5,
                0
            ]
        },
        {
            "name": "Kyle Mccall",
            "city": 1,
            "color": "orange",
            "qualifications": [
                3,
                6,
                7,
                3
            ]
        },
        {
            "name": "Todd Bailey",
            "city": 0,
            "color": "blue",
            "qualifications": [
                5,
                1,
                2,
                5
            ]
        },
        {
            "name": "Sabrina Brandt",
            "city": 0,
            "color": "orange",
            "qualifications": [
                3,
                4,
                0,
                3
            ]
        },
        {
            "name": "Rodney Myers",
            "city": 0,
            "color": "blue",
            "qualifications": [
                5,
                3,
                1,
                7
            ]
        },
        {
            "name": "Mike Ross",
            "city": 1,
            "color": "orange",
            "qualifications": [
                9,
                8,
                1,
                2
            ]
        },
        {
            "name": "Jennifer Wilson",
            "city": 0,
            "color": "blue",
            "qualifications": [
                4,
                9,
                8,
                7
            ]
        },
        {
            "name": "Richard Watkins",
            "city": 0,
            "color": "blue",
            "qualifications": [
                2,
                4,
                1,
                9
            ]
        },
        {
            "name": "Kimberly Henderson",
            "city": 0,
            "color": "blue",
            "qualifications": [
                9,
                2,
                0,
                7
            ]
        },
        {
            "name": "Amy Conrad",
            "city": 1,
            "color": "orange",
            "qualifications": [
                9,
                3,
                1,
                2
            ]
        },
        {
            "name": "Douglas Bell",
            "city": 0,
            "color": "blue",
            "qualifications": [
                6,
                7,
                0,
                3
            ]
        },
        {
            "name": "Lee Frye",
            "city": 1,
            "color": "orange",
            "qualifications": [
                4,
                4,
                3,
                3
            ]
        },
        {
            "name": "Cody Navarro",
            "city": 0,
            "color": "blue",
            "qualifications": [
                0,
                8,
                6,
                1
            ]
        },
        {
            "name": "Janet Clark",
            "city": 0,
            "color": "blue",
            "qualifications": [
                8,
                8,
                6,
                4
            ]
        },
        {
            "name": "Jean Hubbard",
            "city": 1,
            "color": "orange",
            "qualifications": [
                2,
                1,
                7,
                1
            ]
        },
        {
            "name": "Renee Brewer",
            "city": 1,
            "color": "orange",
            "qualifications": [
                3,
                0,
                5,
                3
            ]
        },
        {
            "name": "Tara Adams",
            "city": 1,
            "color": "orange",
            "qualifications": [
                2,
                1,
                6,
                5
            ]
        },
        {
            "name": "Ariana Morris",
            "city": 1,
            "color": "orange",
            "qualifications": [
                3,
                2,
                6,
                4
            ]
        },
        {
            "name": "William Johnson",
            "city": 0,
            "color": "blue",
            "qualifications": [
                8,
                9,
                4,
                2
            ]
        },
        {
            "name": "Mr. Christopher Lyons",
            "city": 0,
            "color": "blue",
            "qualifications": [
                6,
                9,
                8,
                6
            ]
        },
        {
            "name": "Andrew Miller",
            "city": 0,
            "color": "blue",
            "qualifications": [
                1,
                1,
                0,
                7
            ]
        },
        {
            "name": "Eric Robertson",
            "city": 1,
            "color": "orange",
            "qualifications": [
                7,
                7,
                3,
                3
            ]
        },
        {
            "name": "Tammy Moreno",
            "city": 0,
            "color": "blue",
            "qualifications": [
                1,
                9,
                8,
                3
            ]
        },
        {
            "name": "Claudia Ryan",
            "city": 0,
            "color": "orange",
            "qualifications": [
                2,
                7,
                3,
                1
            ]
        },
        {
            "name": "Mark Phillips",
            "city": 0,
            "color": "blue",
            "qualifications": [
                9,
                5,
                9,
                1
            ]
        },
        {
            "name": "John Hanson",
            "city": 0,
            "color": "blue",
            "qualifications": [
                2,
                5,
                7,
                6
            ]
        },
        {
            "name": "Christopher Novak",
            "city": 1,
            "color": "orange",
            "qualifications": [
                7,
                3,
                3,
                3
            ]
        },
        {
            "name": "James Moyer",
            "city": 0,
            "color": "blue",
            "qualifications": [
                3,
                6,
                8,
                8
            ]
        },
        {
            "name": "Jason Parrish",
            "city": 0,
            "color": "blue",
            "qualifications": [
                8,
                8,
                9,
                6
            ]
        },
        {
            "name": "Mark Haynes",
            "city": 0,
            "color": "blue",
            "qualifications": [
                9,
                6,
                4,
                2
            ]
        },
        {
            "name": "Melissa Green",
            "city": 0,
            "color": "blue",
            "qualifications": [
                2,
                5,
                5,
                7
            ]
        },
        {
            "name": "Valerie Fox",
            "city": 1,
            "color": "orange",
            "qualifications": [
                6,
                5,
                0,
                4
            ]
        },
        {
            "name": "Stephanie Lopez",
            "city": 0,
            "color": "blue",
            "qualifications": [
                5,
                6,
                7,
                2
            ]
        },
        {
            "name": "John Greene",
            "city": 0,
            "color": "blue",
            "qualifications": [
                3,
                5,
                2,
                6
            ]
        },
        {
            "name": "Melissa Aguilar",
            "city": 0,
            "color": "blue",
            "qualifications": [
                7,
                6,
                5,
                5
            ]
        },
        {
            "name": "Cheryl Thomas",
            "city": 1,
            "color": "orange",
            "qualifications": [
                6,
                6,
                1,
                6
            ]
        },
        {
            "name": "Crystal Taylor",
            "city": 0,
            "color": "blue",
            "qualifications": [
                1,
                9,
                0,
                2
            ]
        },
        {
            "name": "Keith Williams",
            "city": 0,
            "color": "blue",
            "qualifications": [
                1,
                7,
                0,
                3
            ]
        },
        {
            "name": "Brittany Gross",
            "city": 1,
            "color": "orange",
            "qualifications": [
                5,
                3,
                5,
                4
            ]
        },
        {
            "name": "Jennifer Rodriguez",
            "city": 1,
            "color": "orange",
            "qualifications": [
                7,
                4,
                6,
                0
            ]
        },
        {
            "name": "Jeffrey Rubio",
            "city": 1,
            "color": "orange",
            "qualifications": [
                9,
                7,
                8,
                1
            ]
        },
        {
            "name": "Taylor Blanchard",
            "city": 1,
            "color": "orange",
            "qualifications": [
                8,
                7,
                8,
                8
            ]
        },
        {
            "name": "Cathy Hanson",
            "city": 1,
            "color": "orange",
            "qualifications": [
                9,
                3,
                4,
                2
            ]
        },
        {
            "name": "Donald Ryan",
            "city": 0,
            "color": "blue",
            "qualifications": [
                7,
                1,
                8,
                5
            ]
        },
        {
            "name": "Joseph Miles",
            "city": 0,
            "color": "blue",
            "qualifications": [
                8,
                0,
                8,
                9
            ]
        },
        {
            "name": "Mary Hall",
            "city": 1,
            "color": "orange",
            "qualifications": [
                3,
                8,
                1,
                5
            ]
        },
        {
            "name": "Paul Johnson",
            "city": 0,
            "color": "blue",
            "qualifications": [
                6,
                4,
                9,
                9
            ]
        },
        {
            "name": "Matthew Gillespie",
            "city": 0,
            "color": "blue",
            "qualifications": [
                6,
                5,
                9,
                9
            ]
        },
        {
            "name": "Cody Brady",
            "city": 0,
            "color": "blue",
            "qualifications": [
                7,
                0,
                7,
                8
            ]
        },
        {
            "name": "Roy Turner",
            "city": 1,
            "color": "orange",
            "qualifications": [
                4,
                8,
                6,
                5
            ]
        },
        {
            "name": "Mr. James Dyer",
            "city": 1,
            "color": "orange",
            "qualifications": [
                8,
                8,
                8,
                5
            ]
        },
        {
            "name": "Jason Aguilar",
            "city": 1,
            "color": "orange",
            "qualifications": [
                6,
                8,
                7,
                1
            ]
        },
        {
            "name": "Tara Walter",
            "city": 0,
            "color": "blue",
            "qualifications": [
                2,
                3,
                5,
                9
            ]
        },
        {
            "name": "Daniel Cox",
            "city": 1,
            "color": "orange",
            "qualifications": [
                7,
                8,
                1,
                0
            ]
        },
        {
            "name": "Christine Hall",
            "city": 1,
            "color": "orange",
            "qualifications": [
                8,
                1,
                7,
                0
            ]
        },
        {
            "name": "Jaime Hardin",
            "city": 0,
            "color": "blue",
            "qualifications": [
                5,
                0,
                2,
                1
            ]
        },
        {
            "name": "Tammy Patton",
            "city": 1,
            "color": "orange",
            "qualifications": [
                6,
                8,
                4,
                6
            ]
        },
        {
            "name": "James Maldonado",
            "city": 0,
            "color": "blue",
            "qualifications": [
                8,
                1,
                2,
                6
            ]
        },
        {
            "name": "Stephanie Decker MD",
            "city": 1,
            "color": "orange",
            "qualifications": [
                3,
                3,
                8,
                4
            ]
        },
        {
            "name": "Dr. Matthew Brown",
            "city": 1,
            "color": "orange",
            "qualifications": [
                9,
                6,
                7,
                8
            ]
        },
        {
            "name": "Courtney Johnson",
            "city": 0,
            "color": "blue",
            "qualifications": [
                8,
                7,
                0,
                9
            ]
        },
        {
            "name": "Ricky Powers",
            "city": 0,
            "color": "blue",
            "qualifications": [
                3,
                8,
                2,
                5
            ]
        },
        {
            "name": "Blake Gibson",
            "city": 1,
            "color": "orange",
            "qualifications": [
                5,
                8,
                1,
                5
            ]
        },
        {
            "name": "William Barrett",
            "city": 0,
            "color": "blue",
            "qualifications": [
                3,
                1,
                4,
                2
            ]
        },
        {
            "name": "Andrew Dodson",
            "city": 1,
            "color": "orange",
            "qualifications": [
                0,
                0,
                3,
                0
            ]
        },
        {
            "name": "Stephen Lee",
            "city": 0,
            "color": "blue",
            "qualifications": [
                6,
                0,
                0,
                8
            ]
        },
        {
            "name": "Michelle Kent",
            "city": 0,
            "color": "blue",
            "qualifications": [
                5,
                0,
                4,
                5
            ]
        },
        {
            "name": "James Ramirez",
            "city": 1,
            "color": "orange",
            "qualifications": [
                5,
                2,
                5,
                7
            ]
        },
        {
            "name": "Cory Kemp",
            "city": 0,
            "color": "blue",
            "qualifications": [
                5,
                1,
                3,
                4
            ]
        },
        {
            "name": "Jessica Hall",
            "city": 1,
            "color": "orange",
            "qualifications": [
                0,
                8,
                0,
                5
            ]
        },
        {
            "name": "Kara Gray",
            "city": 1,
            "color": "orange",
            "qualifications": [
                0,
                9,
                3,
                6
            ]
        },
        {
            "name": "Kevin Young",
            "city": 1,
            "color": "orange",
            "qualifications": [
                0,
                9,
                4,
                8
            ]
        },
        {
            "name": "Kenneth Williams",
            "city": 0,
            "color": "blue",
            "qualifications": [
                5,
                9,
                6,
                9
            ]
        },
        {
            "name": "Luis Payne",
            "city": 0,
            "color": "blue",
            "qualifications": [
                9,
                6,
                6,
                5
            ]
        },
        {
            "name": "Carrie Parker",
            "city": 0,
            "color": "blue",
            "qualifications": [
                8,
                9,
                0,
                8
            ]
        },
        {
            "name": "Angel Parrish",
            "city": 0,
            "color": "blue",
            "qualifications": [
                6,
                7,
                0,
                0
            ]
        },
        {
            "name": "Tara Adams",
            "city": 1,
            "color": "orange",
            "qualifications": [
                6,
                0,
                5,
                6
            ]
        },
        {
            "name": "Gregory Jenkins",
            "city": 1,
            "color": "orange",
            "qualifications": [
                7,
                6,
                6,
                7
            ]
        },
        {
            "name": "Patricia Simmons",
            "city": 1,
            "color": "orange",
            "qualifications": [
                1,
                7,
                7,
                1
            ]
        },
        {
            "name": "David Estrada",
            "city": 1,
            "color": "orange",
            "qualifications": [
                4,
                7,
                1,
                0
            ]
        },
        {
            "name": "Rebecca Cole",
            "city": 0,
            "color": "blue",
            "qualifications": [
                4,
                4,
                1,
                6
            ]
        },
        {
            "name": "Robert Sanchez",
            "city": 1,
            "color": "orange",
            "qualifications": [
                2,
                5,
                7,
                0
            ]
        },
        {
            "name": "Sherri Ho",
            "city": 0,
            "color": "blue",
            "qualifications": [
                6,
                0,
                2,
                6
            ]
        },
        {
            "name": "Clinton Bowen",
            "city": 1,
            "color": "orange",
            "qualifications": [
                8,
                3,
                4,
                5
            ]
        },
        {
            "name": "Amber Burns",
            "city": 0,
            "color": "blue",
            "qualifications": [
                0,
                2,
                6,
                6
            ]
        },
        {
            "name": "Shannon Abbott",
            "city": 1,
            "color": "orange",
            "qualifications": [
                4,
                4,
                7,
                3
            ]
        },
        {
            "name": "Joel Martinez",
            "city": 1,
            "color": "orange",
            "qualifications": [
                7,
                3,
                4,
                0
            ]
        },
        {
            "name": "Monica Brown",
            "city": 1,
            "color": "orange",
            "qualifications": [
                4,
                4,
                0,
                9
            ]
        },
        {
            "name": "Jeffery Greer",
            "city": 1,
            "color": "orange",
            "qualifications": [
                5,
                2,
                4,
                6
            ]
        },
        {
            "name": "John Santiago",
            "city": 0,
            "color": "blue",
            "qualifications": [
                8,
                8,
                9,
                6
            ]
        },
        {
            "name": "Sonya Kim",
            "city": 1,
            "color": "orange",
            "qualifications": [
                6,
                8,
                7,
                5
            ]
        },
        {
            "name": "Renee Blevins",
            "city": 1,
            "color": "orange",
            "qualifications": [
                3,
                4,
                8,
                9
            ]
        },
        {
            "name": "Xavier Sims",
            "city": 1,
            "color": "orange",
            "qualifications": [
                3,
                8,
                6,
                0
            ]
        },
        {
            "name": "Daniel Hammond",
            "city": 0,
            "color": "blue",
            "qualifications": [
                1,
                1,
                4,
                7
            ]
        },
        {
            "name": "Melanie Smith",
            "city": 0,
            "color": "blue",
            "qualifications": [
                8,
                6,
                9,
                4
            ]
        },
        {
            "name": "Carl Allen",
            "city": 1,
            "color": "orange",
            "qualifications": [
                9,
                8,
                0,
                5
            ]
        },
        {
            "name": "Stephanie Harris MD",
            "city": 1,
            "color": "orange",
            "qualifications": [
                7,
                3,
                8,
                5
            ]
        },
        {
            "name": "Mary Lewis DDS",
            "city": 1,
            "color": "orange",
            "qualifications": [
                3,
                0,
                0,
                9
            ]
        },
        {
            "name": "Sarah Pitts",
            "city": 1,
            "color": "orange",
            "qualifications": [
                9,
                4,
                7,
                1
            ]
        },
        {
            "name": "Kelly Phillips",
            "city": 1,
            "color": "orange",
            "qualifications": [
                0,
                2,
                3,
                5
            ]
        },
        {
            "name": "Scott Morris",
            "city": 0,
            "color": "blue",
            "qualifications": [
                0,
                6,
                9,
                0
            ]
        },
        {
            "name": "Scott Rogers",
            "city": 1,
            "color": "orange",
            "qualifications": [
                4,
                9,
                4,
                3
            ]
        },
        {
            "name": "Nathan Taylor",
            "city": 1,
            "color": "orange",
            "qualifications": [
                4,
                6,
                3,
                7
            ]
        },
        {
            "name": "Anthony Stewart",
            "city": 0,
            "color": "blue",
            "qualifications": [
                9,
                4,
                4,
                4
            ]
        },
        {
            "name": "Natalie Gonzalez",
            "city": 0,
            "color": "orange",
            "qualifications": [
                9,
                3,
                3,
                7
            ]
        },
        {
            "name": "Melissa Jones",
            "city": 0,
            "color": "blue",
            "qualifications": [
                8,
                7,
                2,
                3
            ]
        },
        {
            "name": "Cassie Harris",
            "city": 1,
            "color": "orange",
            "qualifications": [
                6,
                0,
                2,
                1
            ]
        },
        {
            "name": "Mark Neal",
            "city": 0,
            "color": "blue",
            "qualifications": [
                6,
                8,
                1,
                7
            ]
        },
        {
            "name": "Teresa Davis",
            "city": 0,
            "color": "blue",
            "qualifications": [
                5,
                8,
                1,
                4
            ]
        },
        {
            "name": "Brett Summers",
            "city": 0,
            "color": "blue",
            "qualifications": [
                1,
                5,
                3,
                3
            ]
        },
        {
            "name": "John Fry",
            "city": 0,
            "color": "blue",
            "qualifications": [
                4,
                1,
                1,
                5
            ]
        },
        {
            "name": "Brianna Green",
            "city": 1,
            "color": "orange",
            "qualifications": [
                8,
                8,
                6,
                5
            ]
        },
        {
            "name": "Melanie Sanchez",
            "city": 1,
            "color": "orange",
            "qualifications": [
                1,
                0,
                3,
                6
            ]
        },
        {
            "name": "Lee Snyder",
            "city": 0,
            "color": "blue",
            "qualifications": [
                8,
                1,
                2,
                7
            ]
        },
        {
            "name": "Linda Norman",
            "city": 0,
            "color": "blue",
            "qualifications": [
                0,
                5,
                5,
                7
            ]
        },
        {
            "name": "Crystal Watkins",
            "city": 1,
            "color": "orange",
            "qualifications": [
                2,
                8,
                7,
                6
            ]
        },
        {
            "name": "Joseph Miller",
            "city": 1,
            "color": "orange",
            "qualifications": [
                2,
                0,
                6,
                6
            ]
        },
        {
            "name": "Kelly Evans",
            "city": 1,
            "color": "orange",
            "qualifications": [
                6,
                6,
                2,
                8
            ]
        },
        {
            "name": "Melissa Boyd",
            "city": 0,
            "color": "blue",
            "qualifications": [
                9,
                9,
                7,
                8
            ]
        },
        {
            "name": "Patrick Fowler",
            "city": 0,
            "color": "blue",
            "qualifications": [
                6,
                5,
                9,
                9
            ]
        },
        {
            "name": "Louis Adkins",
            "city": 0,
            "color": "blue",
            "qualifications": [
                8,
                2,
                4,
                8
            ]
        },
        {
            "name": "Shawn Walker",
            "city": 1,
            "color": "orange",
            "qualifications": [
                6,
                4,
                4,
                1
            ]
        },
        {
            "name": "Isaac Gonzalez",
            "city": 1,
            "color": "orange",
            "qualifications": [
                2,
                3,
                5,
                3
            ]
        },
        {
            "name": "Alicia Turner",
            "city": 1,
            "color": "orange",
            "qualifications": [
                0,
                3,
                1,
                6
            ]
        },
        {
            "name": "Amy Thomas",
            "city": 0,
            "color": "blue",
            "qualifications": [
                8,
                5,
                1,
                3
            ]
        },
        {
            "name": "Eric Haney",
            "city": 0,
            "color": "blue",
            "qualifications": [
                1,
                7,
                5,
                9
            ]
        },
        {
            "name": "Tiffany Yates",
            "city": 1,
            "color": "blue",
            "qualifications": [
                8,
                2,
                5,
                1
            ]
        },
        {
            "name": "Ryan Flores",
            "city": 0,
            "color": "blue",
            "qualifications": [
                2,
                2,
                1,
                2
            ]
        },
        {
            "name": "Sara Scott",
            "city": 1,
            "color": "blue",
            "qualifications": [
                3,
                3,
                8,
                3
            ]
        },
        {
            "name": "Vanessa Lambert",
            "city": 1,
            "color": "orange",
            "qualifications": [
                7,
                2,
                9,
                8
            ]
        },
        {
            "name": "Christine Perez",
            "city": 1,
            "color": "orange",
            "qualifications": [
                0,
                1,
                4,
                7
            ]
        },
        {
            "name": "Beth Mitchell",
            "city": 1,
            "color": "orange",
            "qualifications": [
                3,
                8,
                1,
                0
            ]
        },
        {
            "name": "Richard Price",
            "city": 0,
            "color": "blue",
            "qualifications": [
                0,
                5,
                6,
                8
            ]
        },
        {
            "name": "Nicole Chen",
            "city": 1,
            "color": "orange",
            "qualifications": [
                0,
                0,
                5,
                1
            ]
        },
        {
            "name": "Brett Williams",
            "city": 1,
            "color": "orange",
            "qualifications": [
                1,
                3,
                9,
                3
            ]
        },
        {
            "name": "Daniel Long",
            "city": 1,
            "color": "orange",
            "qualifications": [
                4,
                5,
                3,
                7
            ]
        },
        {
            "name": "Patricia Wilkinson",
            "city": 1,
            "color": "blue",
            "qualifications": [
                3,
                4,
                2,
                7
            ]
        },
        {
            "name": "Edward Lynn",
            "city": 0,
            "color": "blue",
            "qualifications": [
                4,
                6,
                7,
                2
            ]
        },
        {
            "name": "Andrea Johnson",
            "city": 0,
            "color": "blue",
            "qualifications": [
                4,
                6,
                6,
                4
            ]
        },
        {
            "name": "Shane Perry",
            "city": 0,
            "color": "blue",
            "qualifications": [
                2,
                4,
                3,
                2
            ]
        },
        {
            "name": "Matthew Moore",
            "city": 0,
            "color": "blue",
            "qualifications": [
                2,
                1,
                0,
                0
            ]
        },
        {
            "name": "Henry Avery",
            "city": 1,
            "color": "orange",
            "qualifications": [
                1,
                4,
                8,
                4
            ]
        },
        {
            "name": "Katie Lynch",
            "city": 0,
            "color": "blue",
            "qualifications": [
                1,
                8,
                4,
                4
            ]
        },
        {
            "name": "Richard Oneill",
            "city": 1,
            "color": "orange",
            "qualifications": [
                1,
                9,
                3,
                4
            ]
        },
        {
            "name": "Mary Ward",
            "city": 1,
            "color": "orange",
            "qualifications": [
                9,
                7,
                0,
                7
            ]
        },
        {
            "name": "Jessica Jensen",
            "city": 1,
            "color": "orange",
            "qualifications": [
                4,
                2,
                2,
                8
            ]
        },
        {
            "name": "Austin Clark",
            "city": 0,
            "color": "blue",
            "qualifications": [
                0,
                2,
                3,
                3
            ]
        },
        {
            "name": "Linda Smith",
            "city": 1,
            "color": "orange",
            "qualifications": [
                8,
                7,
                7,
                7
            ]
        },
        {
            "name": "Kristen Young",
            "city": 1,
            "color": "orange",
            "qualifications": [
                5,
                9,
                4,
                6
            ]
        },
        {
            "name": "Maria Frederick",
            "city": 0,
            "color": "blue",
            "qualifications": [
                5,
                3,
                6,
                1
            ]
        },
        {
            "name": "John Henderson",
            "city": 0,
            "color": "blue",
            "qualifications": [
                8,
                9,
                1,
                9
            ]
        },
        {
            "name": "Cynthia Frost",
            "city": 1,
            "color": "orange",
            "qualifications": [
                4,
                6,
                9,
                7
            ]
        },
        {
            "name": "Katherine Lucas",
            "city": 0,
            "color": "blue",
            "qualifications": [
                2,
                1,
                0,
                9
            ]
        },
        {
            "name": "Melanie Sanford",
            "city": 0,
            "color": "blue",
            "qualifications": [
                7,
                8,
                5,
                4
            ]
        },
        {
            "name": "Michele Zamora",
            "city": 0,
            "color": "blue",
            "qualifications": [
                2,
                3,
                3,
                2
            ]
        },
        {
            "name": "Larry Hubbard",
            "city": 1,
            "color": "orange",
            "qualifications": [
                0,
                7,
                2,
                9
            ]
        },
        {
            "name": "Katherine Barber",
            "city": 0,
            "color": "blue",
            "qualifications": [
                1,
                2,
                8,
                2
            ]
        },
        {
            "name": "April Jones",
            "city": 1,
            "color": "orange",
            "qualifications": [
                4,
                3,
                7,
                0
            ]
        },
        {
            "name": "Jennifer Bradley",
            "city": 0,
            "color": "blue",
            "qualifications": [
                3,
                0,
                4,
                3
            ]
        },
        {
            "name": "James Munoz",
            "city": 1,
            "color": "orange",
            "qualifications": [
                4,
                7,
                6,
                8
            ]
        },
        {
            "name": "Matthew Daniels",
            "city": 1,
            "color": "orange",
            "qualifications": [
                9,
                4,
                1,
                5
            ]
        },
        {
            "name": "Natasha Haas",
            "city": 0,
            "color": "blue",
            "qualifications": [
                7,
                2,
                2,
                8
            ]
        },
        {
            "name": "Chelsea Haney",
            "city": 0,
            "color": "blue",
            "qualifications": [
                5,
                6,
                6,
                4
            ]
        },
        {
            "name": "Raymond Thomas",
            "city": 1,
            "color": "orange",
            "qualifications": [
                6,
                5,
                3,
                1
            ]
        },
        {
            "name": "Joshua Vasquez",
            "city": 0,
            "color": "blue",
            "qualifications": [
                7,
                5,
                9,
                8
            ]
        },
        {
            "name": "Louis White",
            "city": 0,
            "color": "blue",
            "qualifications": [
                7,
                7,
                4,
                8
            ]
        },
        {
            "name": "Rachel Brown",
            "city": 0,
            "color": "blue",
            "qualifications": [
                7,
                6,
                8,
                3
            ]
        },
        {
            "name": "Denise Estrada",
            "city": 0,
            "color": "blue",
            "qualifications": [
                1,
                4,
                2,
                4
            ]
        },
        {
            "name": "Eric Morton",
            "city": 1,
            "color": "orange",
            "qualifications": [
                5,
                8,
                0,
                5
            ]
        },
        {
            "name": "Melissa Morris",
            "city": 0,
            "color": "blue",
            "qualifications": [
                7,
                6,
                6,
                7
            ]
        },
        {
            "name": "Karen Young",
            "city": 0,
            "color": "blue",
            "qualifications": [
                5,
                9,
                1,
                7
            ]
        },
        {
            "name": "Elaine West",
            "city": 1,
            "color": "orange",
            "qualifications": [
                5,
                1,
                4,
                7
            ]
        },
        {
            "name": "Christine Clark",
            "city": 1,
            "color": "orange",
            "qualifications": [
                7,
                8,
                8,
                0
            ]
        },
        {
            "name": "Amy Bailey",
            "city": 1,
            "color": "orange",
            "qualifications": [
                2,
                0,
                0,
                0
            ]
        },
        {
            "name": "Amber Robinson",
            "city": 1,
            "color": "orange",
            "qualifications": [
                0,
                0,
                2,
                9
            ]
        },
        {
            "name": "Kimberly David",
            "city": 1,
            "color": "orange",
            "qualifications": [
                3,
                8,
                6,
                9
            ]
        },
        {
            "name": "Gary Hall",
            "city": 1,
            "color": "orange",
            "qualifications": [
                4,
                9,
                4,
                0
            ]
        },
        {
            "name": "Raymond Adams",
            "city": 0,
            "color": "blue",
            "qualifications": [
                2,
                3,
                9,
                0
            ]
        },
        {
            "name": "Benjamin Greer",
            "city": 0,
            "color": "blue",
            "qualifications": [
                6,
                6,
                4,
                1
            ]
        },
        {
            "name": "Jesse Levine",
            "city": 1,
            "color": "orange",
            "qualifications": [
                6,
                9,
                9,
                1
            ]
        },
        {
            "name": "Anthony Horn",
            "city": 0,
            "color": "blue",
            "qualifications": [
                6,
                9,
                1,
                8
            ]
        },
        {
            "name": "Cheryl Walsh",
            "city": 0,
            "color": "blue",
            "qualifications": [
                6,
                5,
                9,
                6
            ]
        },
        {
            "name": "Connie Potter",
            "city": 1,
            "color": "orange",
            "qualifications": [
                2,
                1,
                2,
                3
            ]
        },
        {
            "name": "Jessica Jones",
            "city": 1,
            "color": "orange",
            "qualifications": [
                2,
                2,
                6,
                1
            ]
        },
        {
            "name": "Tammy Sanchez",
            "city": 1,
            "color": "orange",
            "qualifications": [
                1,
                6,
                8,
                4
            ]
        },
        {
            "name": "Clifford Jackson",
            "city": 0,
            "color": "blue",
            "qualifications": [
                3,
                6,
                1,
                6
            ]
        },
        {
            "name": "Aaron Wilson",
            "city": 1,
            "color": "orange",
            "qualifications": [
                2,
                1,
                2,
                1
            ]
        },
        {
            "name": "Alexander Harris",
            "city": 1,
            "color": "orange",
            "qualifications": [
                4,
                2,
                4,
                5
            ]
        },
        {
            "name": "Erica Williams",
            "city": 1,
            "color": "orange",
            "qualifications": [
                2,
                1,
                0,
                4
            ]
        },
        {
            "name": "Kenneth Riley",
            "city": 1,
            "color": "orange",
            "qualifications": [
                8,
                4,
                8,
                8
            ]
        },
        {
            "name": "Brandon Gonzales",
            "city": 0,
            "color": "orange",
            "qualifications": [
                8,
                1,
                3,
                4
            ]
        },
        {
            "name": "Steven Green",
            "city": 1,
            "color": "orange",
            "qualifications": [
                5,
                8,
                4,
                7
            ]
        },
        {
            "name": "Cory Howard",
            "city": 0,
            "color": "blue",
            "qualifications": [
                7,
                1,
                3,
                9
            ]
        },
        {
            "name": "Danielle Oconnor",
            "city": 1,
            "color": "orange",
            "qualifications": [
                9,
                5,
                4,
                3
            ]
        },
        {
            "name": "Daniel Pitts",
            "city": 0,
            "color": "blue",
            "qualifications": [
                2,
                7,
                6,
                1
            ]
        },
        {
            "name": "Robert Martinez",
            "city": 0,
            "color": "blue",
            "qualifications": [
                0,
                3,
                1,
                7
            ]
        },
        {
            "name": "Gregory Moses",
            "city": 0,
            "color": "blue",
            "qualifications": [
                3,
                0,
                2,
                6
            ]
        },
        {
            "name": "Carmen Harris",
            "city": 0,
            "color": "blue",
            "qualifications": [
                9,
                1,
                0,
                9
            ]
        },
        {
            "name": "Johnny Smith",
            "city": 1,
            "color": "orange",
            "qualifications": [
                0,
                0,
                4,
                2
            ]
        },
        {
            "name": "James Paul",
            "city": 0,
            "color": "blue",
            "qualifications": [
                2,
                5,
                1,
                3
            ]
        },
        {
            "name": "Aaron Jackson",
            "city": 1,
            "color": "orange",
            "qualifications": [
                4,
                4,
                4,
                5
            ]
        },
        {
            "name": "Sharon Gonzalez",
            "city": 0,
            "color": "blue",
            "qualifications": [
                7,
                5,
                6,
                0
            ]
        },
        {
            "name": "Jesus Brock",
            "city": 1,
            "color": "orange",
            "qualifications": [
                5,
                0,
                8,
                2
            ]
        },
        {
            "name": "Ian Roberts",
            "city": 0,
            "color": "blue",
            "qualifications": [
                9,
                2,
                3,
                2
            ]
        },
        {
            "name": "Jessica Brown",
            "city": 1,
            "color": "orange",
            "qualifications": [
                7,
                7,
                1,
                5
            ]
        },
        {
            "name": "Jennifer Burke",
            "city": 0,
            "color": "blue",
            "qualifications": [
                9,
                8,
                2,
                8
            ]
        },
        {
            "name": "Debra Wells",
            "city": 1,
            "color": "orange",
            "qualifications": [
                0,
                6,
                0,
                1
            ]
        },
        {
            "name": "Jessica Heath",
            "city": 1,
            "color": "orange",
            "qualifications": [
                8,
                9,
                7,
                0
            ]
        },
        {
            "name": "Brian King",
            "city": 0,
            "color": "blue",
            "qualifications": [
                4,
                4,
                6,
                0
            ]
        },
        {
            "name": "James Webb",
            "city": 1,
            "color": "orange",
            "qualifications": [
                3,
                3,
                6,
                7
            ]
        },
        {
            "name": "Jerry Church",
            "city": 1,
            "color": "orange",
            "qualifications": [
                1,
                8,
                0,
                1
            ]
        },
        {
            "name": "Audrey Aguilar",
            "city": 1,
            "color": "orange",
            "qualifications": [
                2,
                3,
                2,
                3
            ]
        },
        {
            "name": "George Holmes",
            "city": 0,
            "color": "blue",
            "qualifications": [
                1,
                2,
                0,
                3
            ]
        },
        {
            "name": "Julie Higgins",
            "city": 1,
            "color": "orange",
            "qualifications": [
                5,
                1,
                0,
                1
            ]
        },
        {
            "name": "Travis Hoffman",
            "city": 1,
            "color": "orange",
            "qualifications": [
                7,
                8,
                1,
                6
            ]
        },
        {
            "name": "Eric Walker",
            "city": 0,
            "color": "blue",
            "qualifications": [
                0,
                7,
                3,
                4
            ]
        },
        {
            "name": "Sierra Carroll",
            "city": 1,
            "color": "orange",
            "qualifications": [
                8,
                5,
                5,
                2
            ]
        },
        {
            "name": "Gregory Smith",
            "city": 0,
            "color": "blue",
            "qualifications": [
                1,
                7,
                2,
                1
            ]
        },
        {
            "name": "George Delacruz",
            "city": 1,
            "color": "orange",
            "qualifications": [
                2,
                4,
                7,
                1
            ]
        },
        {
            "name": "Matthew Serrano",
            "city": 1,
            "color": "orange",
            "qualifications": [
                3,
                2,
                6,
                0
            ]
        },
        {
            "name": "Susan Hines",
            "city": 1,
            "color": "orange",
            "qualifications": [
                5,
                8,
                7,
                3
            ]
        },
        {
            "name": "Wanda Barnes",
            "city": 1,
            "color": "orange",
            "qualifications": [
                0,
                2,
                1,
                7
            ]
        },
        {
            "name": "Matthew Vance",
            "city": 0,
            "color": "blue",
            "qualifications": [
                1,
                4,
                4,
                5
            ]
        },
        {
            "name": "Todd Vega",
            "city": 0,
            "color": "blue",
            "qualifications": [
                5,
                1,
                7,
                6
            ]
        },
        {
            "name": "Scott White",
            "city": 0,
            "color": "blue",
            "qualifications": [
                3,
                6,
                4,
                5
            ]
        },
        {
            "name": "Shannon Davis",
            "city": 0,
            "color": "blue",
            "qualifications": [
                9,
                8,
                3,
                3
            ]
        },
        {
            "name": "Alyssa Francis",
            "city": 0,
            "color": "blue",
            "qualifications": [
                3,
                7,
                9,
                2
            ]
        },
        {
            "name": "Gregory Ryan",
            "city": 0,
            "color": "blue",
            "qualifications": [
                3,
                0,
                2,
                1
            ]
        },
        {
            "name": "Diana Taylor",
            "city": 1,
            "color": "orange",
            "qualifications": [
                9,
                5,
                6,
                2
            ]
        },
        {
            "name": "Chelsea Phillips",
            "city": 0,
            "color": "blue",
            "qualifications": [
                4,
                3,
                3,
                4
            ]
        },
        {
            "name": "Anne Hunt",
            "city": 1,
            "color": "orange",
            "qualifications": [
                6,
                3,
                5,
                8
            ]
        },
        {
            "name": "Becky Edwards",
            "city": 0,
            "color": "blue",
            "qualifications": [
                8,
                8,
                4,
                0
            ]
        },
        {
            "name": "Lindsey Velasquez",
            "city": 1,
            "color": "orange",
            "qualifications": [
                6,
                8,
                3,
                7
            ]
        },
        {
            "name": "Kelli Duncan",
            "city": 1,
            "color": "blue",
            "qualifications": [
                8,
                3,
                4,
                6
            ]
        },
        {
            "name": "Tammy Leon",
            "city": 0,
            "color": "blue",
            "qualifications": [
                6,
                7,
                5,
                3
            ]
        },
        {
            "name": "Toni Evans",
            "city": 0,
            "color": "blue",
            "qualifications": [
                4,
                2,
                9,
                9
            ]
        },
        {
            "name": "Rhonda Reynolds",
            "city": 1,
            "color": "orange",
            "qualifications": [
                0,
                5,
                5,
                3
            ]
        },
        {
            "name": "Terry Smith",
            "city": 1,
            "color": "orange",
            "qualifications": [
                2,
                8,
                3,
                8
            ]
        },
        {
            "name": "Anna Moore",
            "city": 0,
            "color": "blue",
            "qualifications": [
                0,
                3,
                7,
                6
            ]
        },
        {
            "name": "Steven Conley",
            "city": 0,
            "color": "blue",
            "qualifications": [
                9,
                9,
                7,
                9
            ]
        },
        {
            "name": "Nicholas Richardson",
            "city": 0,
            "color": "blue",
            "qualifications": [
                3,
                8,
                1,
                6
            ]
        },
        {
            "name": "Melissa Brown",
            "city": 0,
            "color": "blue",
            "qualifications": [
                1,
                3,
                5,
                7
            ]
        },
        {
            "name": "Susan Mckinney",
            "city": 1,
            "color": "orange",
            "qualifications": [
                9,
                7,
                7,
                2
            ]
        },
        {
            "name": "Kimberly Clay",
            "city": 1,
            "color": "orange",
            "qualifications": [
                8,
                6,
                5,
                0
            ]
        },
        {
            "name": "Jon Wolfe",
            "city": 0,
            "color": "blue",
            "qualifications": [
                0,
                4,
                1,
                4
            ]
        },
        {
            "name": "Taylor Murphy",
            "city": 1,
            "color": "orange",
            "qualifications": [
                5,
                5,
                1,
                2
            ]
        },
        {
            "name": "Melissa Miller",
            "city": 0,
            "color": "blue",
            "qualifications": [
                4,
                4,
                3,
                5
            ]
        },
        {
            "name": "Heidi Monroe",
            "city": 1,
            "color": "orange",
            "qualifications": [
                6,
                5,
                2,
                6
            ]
        },
        {
            "name": "Chad Buck",
            "city": 1,
            "color": "orange",
            "qualifications": [
                2,
                2,
                2,
                7
            ]
        },
        {
            "name": "Cathy Dean",
            "city": 1,
            "color": "orange",
            "qualifications": [
                8,
                9,
                4,
                1
            ]
        },
        {
            "name": "Michael Brown",
            "city": 1,
            "color": "orange",
            "qualifications": [
                0,
                5,
                8,
                0
            ]
        },
        {
            "name": "Alan Green",
            "city": 0,
            "color": "blue",
            "qualifications": [
                0,
                7,
                3,
                6
            ]
        },
        {
            "name": "Jennifer Brown",
            "city": 0,
            "color": "blue",
            "qualifications": [
                4,
                3,
                5,
                2
            ]
        },
        {
            "name": "Emily Medina",
            "city": 1,
            "color": "orange",
            "qualifications": [
                8,
                4,
                2,
                9
            ]
        },
        {
            "name": "Rachel Nash",
            "city": 1,
            "color": "orange",
            "qualifications": [
                7,
                9,
                5,
                3
            ]
        },
        {
            "name": "Ryan Marks",
            "city": 0,
            "color": "blue",
            "qualifications": [
                0,
                2,
                7,
                5
            ]
        },
        {
            "name": "Sophia Buchanan",
            "city": 0,
            "color": "orange",
            "qualifications": [
                1,
                4,
                2,
                4
            ]
        },
        {
            "name": "Keith Baker",
            "city": 1,
            "color": "orange",
            "qualifications": [
                3,
                6,
                9,
                7
            ]
        },
        {
            "name": "Jessica Keller",
            "city": 0,
            "color": "blue",
            "qualifications": [
                4,
                9,
                6,
                5
            ]
        },
        {
            "name": "Tricia King MD",
            "city": 1,
            "color": "orange",
            "qualifications": [
                3,
                3,
                6,
                3
            ]
        },
        {
            "name": "Matthew Williams",
            "city": 0,
            "color": "blue",
            "qualifications": [
                7,
                7,
                8,
                3
            ]
        },
        {
            "name": "Cynthia Pierce",
            "city": 0,
            "color": "blue",
            "qualifications": [
                4,
                4,
                2,
                3
            ]
        },
        {
            "name": "Anthony King",
            "city": 0,
            "color": "blue",
            "qualifications": [
                4,
                4,
                7,
                6
            ]
        },
        {
            "name": "Suzanne Robinson",
            "city": 0,
            "color": "blue",
            "qualifications": [
                8,
                8,
                9,
                4
            ]
        },
        {
            "name": "Ellen Austin",
            "city": 0,
            "color": "blue",
            "qualifications": [
                5,
                3,
                3,
                1
            ]
        },
        {
            "name": "Joshua Bishop DVM",
            "city": 1,
            "color": "orange",
            "qualifications": [
                0,
                5,
                8,
                4
            ]
        },
        {
            "name": "Luis Rodriguez",
            "city": 0,
            "color": "orange",
            "qualifications": [
                2,
                1,
                9,
                2
            ]
        },
        {
            "name": "Kaylee Crane",
            "city": 1,
            "color": "orange",
            "qualifications": [
                0,
                4,
                5,
                8
            ]
        },
        {
            "name": "Michelle Sheppard",
            "city": 0,
            "color": "blue",
            "qualifications": [
                0,
                2,
                8,
                6
            ]
        },
        {
            "name": "Teresa White",
            "city": 1,
            "color": "orange",
            "qualifications": [
                3,
                6,
                4,
                7
            ]
        },
        {
            "name": "Jeffrey Robinson",
            "city": 1,
            "color": "orange",
            "qualifications": [
                2,
                3,
                6,
                6
            ]
        },
        {
            "name": "Maureen Thomas",
            "city": 0,
            "color": "blue",
            "qualifications": [
                5,
                8,
                2,
                8
            ]
        },
        {
            "name": "Kimberly Sanchez",
            "city": 0,
            "color": "blue",
            "qualifications": [
                0,
                8,
                2,
                0
            ]
        },
        {
            "name": "Robert Jenkins",
            "city": 0,
            "color": "blue",
            "qualifications": [
                4,
                1,
                7,
                7
            ]
        },
        {
            "name": "Patricia Jacobs",
            "city": 1,
            "color": "orange",
            "qualifications": [
                4,
                7,
                2,
                3
            ]
        },
        {
            "name": "Jamie Edwards",
            "city": 1,
            "color": "orange",
            "qualifications": [
                1,
                7,
                8,
                8
            ]
        },
        {
            "name": "Lori Norris",
            "city": 0,
            "color": "blue",
            "qualifications": [
                8,
                2,
                9,
                8
            ]
        },
        {
            "name": "David Cooper",
            "city": 0,
            "color": "blue",
            "qualifications": [
                3,
                6,
                5,
                0
            ]
        },
        {
            "name": "Mark Perez",
            "city": 0,
            "color": "blue",
            "qualifications": [
                4,
                5,
                1,
                0
            ]
        },
        {
            "name": "William Castillo",
            "city": 0,
            "color": "blue",
            "qualifications": [
                2,
                0,
                2,
                7
            ]
        },
        {
            "name": "Jenna Edwards",
            "city": 0,
            "color": "blue",
            "qualifications": [
                1,
                7,
                8,
                7
            ]
        },
        {
            "name": "Peter Rivera DDS",
            "city": 0,
            "color": "blue",
            "qualifications": [
                4,
                9,
                5,
                1
            ]
        },
        {
            "name": "Traci Brown",
            "city": 1,
            "color": "orange",
            "qualifications": [
                1,
                7,
                4,
                5
            ]
        },
        {
            "name": "Edgar Boyd",
            "city": 0,
            "color": "blue",
            "qualifications": [
                6,
                0,
                0,
                0
            ]
        },
        {
            "name": "Michael Myers",
            "city": 1,
            "color": "orange",
            "qualifications": [
                3,
                2,
                0,
                9
            ]
        },
        {
            "name": "Shannon Hughes",
            "city": 1,
            "color": "orange",
            "qualifications": [
                1,
                3,
                6,
                2
            ]
        },
        {
            "name": "Aaron Boyd",
            "city": 1,
            "color": "orange",
            "qualifications": [
                8,
                8,
                9,
                2
            ]
        },
        {
            "name": "Christopher Stafford",
            "city": 0,
            "color": "blue",
            "qualifications": [
                1,
                2,
                2,
                5
            ]
        },
        {
            "name": "David Scott",
            "city": 1,
            "color": "orange",
            "qualifications": [
                5,
                1,
                7,
                4
            ]
        },
        {
            "name": "Mrs. Courtney Bowman",
            "city": 1,
            "color": "orange",
            "qualifications": [
                7,
                5,
                3,
                6
            ]
        },
        {
            "name": "Michael Klein",
            "city": 1,
            "color": "orange",
            "qualifications": [
                3,
                1,
                3,
                1
            ]
        },
        {
            "name": "Tammy George",
            "city": 0,
            "color": "blue",
            "qualifications": [
                1,
                5,
                7,
                3
            ]
        },
        {
            "name": "Autumn Scott",
            "city": 1,
            "color": "blue",
            "qualifications": [
                7,
                0,
                6,
                8
            ]
        },
        {
            "name": "Kara Manning",
            "city": 0,
            "color": "orange",
            "qualifications": [
                7,
                2,
                2,
                5
            ]
        },
        {
            "name": "Ryan Anderson",
            "city": 1,
            "color": "orange",
            "qualifications": [
                2,
                8,
                6,
                5
            ]
        },
        {
            "name": "Michael Ho",
            "city": 0,
            "color": "blue",
            "qualifications": [
                5,
                7,
                7,
                4
            ]
        },
        {
            "name": "Brian Williams",
            "city": 0,
            "color": "blue",
            "qualifications": [
                4,
                3,
                0,
                4
            ]
        },
        {
            "name": "Ms. Peggy Brown",
            "city": 1,
            "color": "orange",
            "qualifications": [
                5,
                9,
                7,
                8
            ]
        },
        {
            "name": "Crystal Lucas",
            "city": 0,
            "color": "blue",
            "qualifications": [
                5,
                1,
                9,
                4
            ]
        },
        {
            "name": "Mercedes Castro",
            "city": 0,
            "color": "blue",
            "qualifications": [
                6,
                3,
                0,
                5
            ]
        },
        {
            "name": "Sheila Adams DVM",
            "city": 0,
            "color": "blue",
            "qualifications": [
                6,
                6,
                4,
                0
            ]
        },
        {
            "name": "William Lee",
            "city": 0,
            "color": "blue",
            "qualifications": [
                9,
                4,
                7,
                0
            ]
        },
        {
            "name": "Michael Ramirez",
            "city": 0,
            "color": "blue",
            "qualifications": [
                2,
                5,
                3,
                2
            ]
        },
        {
            "name": "Nancy Nguyen",
            "city": 0,
            "color": "blue",
            "qualifications": [
                5,
                9,
                6,
                3
            ]
        },
        {
            "name": "Kristy Mendoza",
            "city": 0,
            "color": "blue",
            "qualifications": [
                8,
                8,
                5,
                8
            ]
        },
        {
            "name": "Michael Ferguson",
            "city": 0,
            "color": "blue",
            "qualifications": [
                9,
                6,
                5,
                2
            ]
        },
        {
            "name": "John Ho",
            "city": 1,
            "color": "orange",
            "qualifications": [
                5,
                4,
                6,
                0
            ]
        },
        {
            "name": "Shannon Miller",
            "city": 1,
            "color": "orange",
            "qualifications": [
                3,
                7,
                8,
                4
            ]
        },
        {
            "name": "Pamela Henderson",
            "city": 1,
            "color": "blue",
            "qualifications": [
                9,
                4,
                7,
                4
            ]
        },
        {
            "name": "Chelsea Baker",
            "city": 0,
            "color": "blue",
            "qualifications": [
                7,
                3,
                2,
                4
            ]
        },
        {
            "name": "Holly Mcgee",
            "city": 1,
            "color": "orange",
            "qualifications": [
                3,
                3,
                7,
                9
            ]
        },
        {
            "name": "Wendy Ortega",
            "city": 0,
            "color": "blue",
            "qualifications": [
                9,
                6,
                8,
                9
            ]
        },
        {
            "name": "William Black",
            "city": 0,
            "color": "blue",
            "qualifications": [
                2,
                1,
                1,
                9
            ]
        },
        {
            "name": "Richard Jackson",
            "city": 0,
            "color": "blue",
            "qualifications": [
                9,
                7,
                3,
                3
            ]
        },
        {
            "name": "Kayla Smith",
            "city": 0,
            "color": "blue",
            "qualifications": [
                3,
                1,
                9,
                9
            ]
        },
        {
            "name": "Brandi Lawson",
            "city": 0,
            "color": "blue",
            "qualifications": [
                6,
                9,
                4,
                6
            ]
        },
        {
            "name": "Norma Tyler",
            "city": 1,
            "color": "orange",
            "qualifications": [
                7,
                1,
                6,
                9
            ]
        },
        {
            "name": "Marcus Owens",
            "city": 0,
            "color": "blue",
            "qualifications": [
                1,
                1,
                8,
                3
            ]
        },
        {
            "name": "Mr. Robert Richardson",
            "city": 0,
            "color": "blue",
            "qualifications": [
                0,
                8,
                7,
                3
            ]
        },
        {
            "name": "Andrew Evans",
            "city": 1,
            "color": "orange",
            "qualifications": [
                1,
                2,
                7,
                2
            ]
        },
        {
            "name": "James Jensen",
            "city": 1,
            "color": "orange",
            "qualifications": [
                5,
                9,
                5,
                2
            ]
        },
        {
            "name": "Theresa Oconnor",
            "city": 0,
            "color": "blue",
            "qualifications": [
                8,
                2,
                2,
                4
            ]
        },
        {
            "name": "Denise Hall",
            "city": 0,
            "color": "blue",
            "qualifications": [
                9,
                1,
                5,
                2
            ]
        },
        {
            "name": "William Sullivan",
            "city": 1,
            "color": "orange",
            "qualifications": [
                8,
                1,
                9,
                3
            ]
        },
        {
            "name": "Rhonda Thompson",
            "city": 0,
            "color": "orange",
            "qualifications": [
                6,
                9,
                0,
                2
            ]
        },
        {
            "name": "Rebecca Herrera",
            "city": 1,
            "color": "orange",
            "qualifications": [
                9,
                3,
                9,
                4
            ]
        },
        {
            "name": "Robert Oliver",
            "city": 0,
            "color": "blue",
            "qualifications": [
                5,
                4,
                9,
                3
            ]
        },
        {
            "name": "Erica Wilkinson",
            "city": 1,
            "color": "orange",
            "qualifications": [
                9,
                6,
                4,
                3
            ]
        },
        {
            "name": "Cindy Maddox",
            "city": 1,
            "color": "orange",
            "qualifications": [
                3,
                0,
                5,
                4
            ]
        },
        {
            "name": "George Jones",
            "city": 1,
            "color": "orange",
            "qualifications": [
                9,
                9,
                9,
                3
            ]
        },
        {
            "name": "Jose Bowen",
            "city": 0,
            "color": "blue",
            "qualifications": [
                8,
                8,
                5,
                6
            ]
        },
        {
            "name": "Joel Miller",
            "city": 0,
            "color": "blue",
            "qualifications": [
                9,
                5,
                1,
                4
            ]
        },
        {
            "name": "Norman Allen",
            "city": 1,
            "color": "orange",
            "qualifications": [
                8,
                1,
                3,
                0
            ]
        },
        {
            "name": "Lori Thompson",
            "city": 0,
            "color": "blue",
            "qualifications": [
                4,
                2,
                3,
                3
            ]
        },
        {
            "name": "James Delgado",
            "city": 1,
            "color": "orange",
            "qualifications": [
                1,
                1,
                7,
                1
            ]
        },
        {
            "name": "Sharon Wolf",
            "city": 1,
            "color": "orange",
            "qualifications": [
                6,
                7,
                2,
                9
            ]
        },
        {
            "name": "William Alvarez",
            "city": 0,
            "color": "blue",
            "qualifications": [
                8,
                4,
                8,
                2
            ]
        },
        {
            "name": "Maxwell Smith",
            "city": 0,
            "color": "blue",
            "qualifications": [
                3,
                6,
                7,
                7
            ]
        },
        {
            "name": "Diana Thomas",
            "city": 1,
            "color": "orange",
            "qualifications": [
                5,
                5,
                1,
                1
            ]
        },
        {
            "name": "Matthew Kramer",
            "city": 0,
            "color": "blue",
            "qualifications": [
                7,
                9,
                9,
                0
            ]
        },
        {
            "name": "Lauren Chavez",
            "city": 1,
            "color": "orange",
            "qualifications": [
                4,
                3,
                4,
                2
            ]
        },
        {
            "name": "Sarah Mitchell",
            "city": 1,
            "color": "orange",
            "qualifications": [
                5,
                5,
                5,
                3
            ]
        },
        {
            "name": "Eric Gamble",
            "city": 1,
            "color": "orange",
            "qualifications": [
                2,
                9,
                8,
                8
            ]
        },
        {
            "name": "Jerry Cook",
            "city": 1,
            "color": "orange",
            "qualifications": [
                7,
                9,
                4,
                3
            ]
        },
        {
            "name": "Rebecca Butler",
            "city": 1,
            "color": "orange",
            "qualifications": [
                0,
                3,
                3,
                2
            ]
        },
        {
            "name": "George Lopez",
            "city": 0,
            "color": "blue",
            "qualifications": [
                7,
                4,
                5,
                5
            ]
        },
        {
            "name": "Nicholas Smith",
            "city": 1,
            "color": "orange",
            "qualifications": [
                1,
                9,
                1,
                0
            ]
        },
        {
            "name": "Gary Gray",
            "city": 0,
            "color": "blue",
            "qualifications": [
                8,
                3,
                7,
                0
            ]
        },
        {
            "name": "Molly Moreno",
            "city": 0,
            "color": "blue",
            "qualifications": [
                9,
                0,
                5,
                1
            ]
        },
        {
            "name": "Cody Brown",
            "city": 0,
            "color": "blue",
            "qualifications": [
                6,
                7,
                8,
                1
            ]
        },
        {
            "name": "John Murphy",
            "city": 0,
            "color": "blue",
            "qualifications": [
                2,
                6,
                5,
                1
            ]
        },
        {
            "name": "Jose Grant",
            "city": 0,
            "color": "blue",
            "qualifications": [
                7,
                2,
                1,
                9
            ]
        },
        {
            "name": "Katrina Brown",
            "city": 0,
            "color": "blue",
            "qualifications": [
                8,
                4,
                9,
                7
            ]
        },
        {
            "name": "Anthony Mitchell",
            "city": 0,
            "color": "blue",
            "qualifications": [
                2,
                1,
                5,
                6
            ]
        },
        {
            "name": "Sheri Daniel",
            "city": 1,
            "color": "orange",
            "qualifications": [
                4,
                7,
                2,
                1
            ]
        },
        {
            "name": "Michael Moran",
            "city": 1,
            "color": "orange",
            "qualifications": [
                3,
                3,
                7,
                0
            ]
        },
        {
            "name": "Brian Potts",
            "city": 1,
            "color": "orange",
            "qualifications": [
                5,
                1,
                6,
                3
            ]
        },
        {
            "name": "Michael Tate",
            "city": 0,
            "color": "blue",
            "qualifications": [
                1,
                8,
                9,
                1
            ]
        },
        {
            "name": "Mark Gomez",
            "city": 0,
            "color": "blue",
            "qualifications": [
                2,
                2,
                9,
                3
            ]
        },
        {
            "name": "Ryan Lewis",
            "city": 1,
            "color": "orange",
            "qualifications": [
                5,
                1,
                3,
                6
            ]
        },
        {
            "name": "Zachary Heath",
            "city": 1,
            "color": "orange",
            "qualifications": [
                9,
                3,
                2,
                2
            ]
        },
        {
            "name": "Carol Young",
            "city": 1,
            "color": "orange",
            "qualifications": [
                4,
                9,
                7,
                3
            ]
        },
        {
            "name": "Michael Velez",
            "city": 1,
            "color": "orange",
            "qualifications": [
                5,
                4,
                6,
                0
            ]
        },
        {
            "name": "Bruce Gonzalez",
            "city": 1,
            "color": "orange",
            "qualifications": [
                2,
                9,
                2,
                1
            ]
        },
        {
            "name": "Jacqueline Tucker",
            "city": 0,
            "color": "blue",
            "qualifications": [
                0,
                2,
                0,
                2
            ]
        },
        {
            "name": "Eric Booth",
            "city": 1,
            "color": "orange",
            "qualifications": [
                1,
                6,
                1,
                6
            ]
        },
        {
            "name": "William Robinson",
            "city": 1,
            "color": "orange",
            "qualifications": [
                3,
                4,
                2,
                1
            ]
        },
        {
            "name": "Dr. Cameron Wilson",
            "city": 0,
            "color": "blue",
            "qualifications": [
                2,
                7,
                5,
                3
            ]
        },
        {
            "name": "Rachel Rodriguez",
            "city": 0,
            "color": "blue",
            "qualifications": [
                5,
                1,
                2,
                3
            ]
        },
        {
            "name": "Dawn Ramirez",
            "city": 0,
            "color": "blue",
            "qualifications": [
                1,
                4,
                3,
                0
            ]
        },
        {
            "name": "Blake Silva",
            "city": 0,
            "color": "blue",
            "qualifications": [
                2,
                9,
                5,
                7
            ]
        },
        {
            "name": "William Beck",
            "city": 1,
            "color": "orange",
            "qualifications": [
                3,
                2,
                7,
                1
            ]
        },
        {
            "name": "Vincent Fleming",
            "city": 1,
            "color": "orange",
            "qualifications": [
                1,
                9,
                2,
                1
            ]
        },
        {
            "name": "Joshua Smith",
            "city": 1,
            "color": "orange",
            "qualifications": [
                2,
                3,
                2,
                6
            ]
        },
        {
            "name": "Gina Bailey",
            "city": 0,
            "color": "blue",
            "qualifications": [
                1,
                5,
                6,
                1
            ]
        },
        {
            "name": "Tara Ray",
            "city": 0,
            "color": "blue",
            "qualifications": [
                1,
                1,
                8,
                2
            ]
        },
        {
            "name": "Alicia Camacho",
            "city": 1,
            "color": "orange",
            "qualifications": [
                9,
                0,
                8,
                1
            ]
        },
        {
            "name": "Jennifer Fleming",
            "city": 0,
            "color": "blue",
            "qualifications": [
                8,
                0,
                8,
                3
            ]
        },
        {
            "name": "Stephen Lutz MD",
            "city": 1,
            "color": "orange",
            "qualifications": [
                4,
                5,
                4,
                4
            ]
        },
        {
            "name": "John Rowe",
            "city": 1,
            "color": "orange",
            "qualifications": [
                5,
                8,
                3,
                9
            ]
        },
        {
            "name": "Colin Matthews",
            "city": 1,
            "color": "orange",
            "qualifications": [
                6,
                3,
                1,
                0
            ]
        },
        {
            "name": "Scott Brown",
            "city": 0,
            "color": "blue",
            "qualifications": [
                4,
                9,
                2,
                3
            ]
        },
        {
            "name": "Derek Mcbride",
            "city": 1,
            "color": "orange",
            "qualifications": [
                0,
                0,
                0,
                1
            ]
        },
        {
            "name": "Jessica Barnes",
            "city": 0,
            "color": "blue",
            "qualifications": [
                3,
                0,
                8,
                4
            ]
        },
        {
            "name": "Brian Harris",
            "city": 0,
            "color": "blue",
            "qualifications": [
                9,
                0,
                3,
                2
            ]
        },
        {
            "name": "William Rodriguez",
            "city": 0,
            "color": "blue",
            "qualifications": [
                2,
                7,
                3,
                9
            ]
        },
        {
            "name": "Michael Brown",
            "city": 0,
            "color": "blue",
            "qualifications": [
                2,
                8,
                6,
                9
            ]
        },
        {
            "name": "Erica Bernard",
            "city": 0,
            "color": "blue",
            "qualifications": [
                6,
                7,
                0,
                6
            ]
        },
        {
            "name": "Yvonne Schaefer",
            "city": 1,
            "color": "orange",
            "qualifications": [
                2,
                2,
                1,
                6
            ]
        },
        {
            "name": "Marcus Rivas",
            "city": 1,
            "color": "orange",
            "qualifications": [
                0,
                7,
                6,
                9
            ]
        },
        {
            "name": "James Garcia",
            "city": 0,
            "color": "blue",
            "qualifications": [
                5,
                5,
                4,
                5
            ]
        },
        {
            "name": "Lisa Dixon",
            "city": 0,
            "color": "blue",
            "qualifications": [
                3,
                5,
                7,
                1
            ]
        },
        {
            "name": "Adam Salas",
            "city": 0,
            "color": "blue",
            "qualifications": [
                2,
                0,
                7,
                3
            ]
        },
        {
            "name": "Kristine Nichols",
            "city": 1,
            "color": "orange",
            "qualifications": [
                3,
                6,
                7,
                9
            ]
        },
        {
            "name": "Melissa French",
            "city": 0,
            "color": "blue",
            "qualifications": [
                8,
                1,
                7,
                1
            ]
        },
        {
            "name": "Christopher Guzman",
            "city": 0,
            "color": "blue",
            "qualifications": [
                4,
                9,
                6,
                4
            ]
        },
        {
            "name": "Ryan Matthews",
            "city": 0,
            "color": "blue",
            "qualifications": [
                9,
                8,
                3,
                8
            ]
        },
        {
            "name": "Manuel Daniels",
            "city": 1,
            "color": "orange",
            "qualifications": [
                3,
                4,
                0,
                9
            ]
        },
        {
            "name": "Joseph Ferguson",
            "city": 1,
            "color": "orange",
            "qualifications": [
                7,
                2,
                8,
                6
            ]
        },
        {
            "name": "Charles Edwards",
            "city": 1,
            "color": "orange",
            "qualifications": [
                0,
                0,
                0,
                6
            ]
        },
        {
            "name": "James Pena",
            "city": 1,
            "color": "orange",
            "qualifications": [
                3,
                5,
                0,
                9
            ]
        },
        {
            "name": "Christina Cox",
            "city": 1,
            "color": "orange",
            "qualifications": [
                4,
                6,
                0,
                5
            ]
        },
        {
            "name": "Paula Morris",
            "city": 1,
            "color": "orange",
            "qualifications": [
                1,
                8,
                1,
                2
            ]
        },
        {
            "name": "Michael Fisher",
            "city": 1,
            "color": "orange",
            "qualifications": [
                2,
                6,
                4,
                8
            ]
        },
        {
            "name": "Jordan Morgan",
            "city": 0,
            "color": "blue",
            "qualifications": [
                4,
                0,
                6,
                9
            ]
        },
        {
            "name": "George Flores",
            "city": 0,
            "color": "blue",
            "qualifications": [
                7,
                0,
                4,
                9
            ]
        },
        {
            "name": "Brent Randolph",
            "city": 1,
            "color": "orange",
            "qualifications": [
                4,
                8,
                3,
                8
            ]
        },
        {
            "name": "David Gray",
            "city": 0,
            "color": "blue",
            "qualifications": [
                0,
                2,
                9,
                3
            ]
        },
        {
            "name": "David Campbell",
            "city": 0,
            "color": "blue",
            "qualifications": [
                8,
                0,
                4,
                5
            ]
        },
        {
            "name": "Tina Thomas",
            "city": 1,
            "color": "orange",
            "qualifications": [
                9,
                8,
                4,
                5
            ]
        },
        {
            "name": "Amy Alvarado",
            "city": 0,
            "color": "blue",
            "qualifications": [
                1,
                5,
                3,
                0
            ]
        },
        {
            "name": "Rose Kramer MD",
            "city": 1,
            "color": "orange",
            "qualifications": [
                8,
                4,
                2,
                8
            ]
        },
        {
            "name": "John Henry",
            "city": 0,
            "color": "blue",
            "qualifications": [
                3,
                8,
                8,
                6
            ]
        },
        {
            "name": "James Mcdonald",
            "city": 0,
            "color": "blue",
            "qualifications": [
                8,
                0,
                6,
                2
            ]
        },
        {
            "name": "Isabella Williamson",
            "city": 1,
            "color": "orange",
            "qualifications": [
                1,
                0,
                9,
                9
            ]
        },
        {
            "name": "Erica Robertson",
            "city": 0,
            "color": "blue",
            "qualifications": [
                6,
                5,
                6,
                8
            ]
        },
        {
            "name": "Sara Huang",
            "city": 1,
            "color": "orange",
            "qualifications": [
                6,
                1,
                0,
                1
            ]
        },
        {
            "name": "Gregory Wallace",
            "city": 0,
            "color": "blue",
            "qualifications": [
                2,
                1,
                9,
                7
            ]
        },
        {
            "name": "Lisa Blevins",
            "city": 0,
            "color": "blue",
            "qualifications": [
                1,
                5,
                9,
                7
            ]
        },
        {
            "name": "Johnny Hart",
            "city": 0,
            "color": "blue",
            "qualifications": [
                6,
                6,
                5,
                5
            ]
        },
        {
            "name": "Edward Schroeder",
            "city": 0,
            "color": "blue",
            "qualifications": [
                4,
                0,
                8,
                1
            ]
        },
        {
            "name": "Amanda Evans",
            "city": 1,
            "color": "orange",
            "qualifications": [
                4,
                6,
                4,
                7
            ]
        },
        {
            "name": "Jill Rogers",
            "city": 1,
            "color": "orange",
            "qualifications": [
                1,
                5,
                3,
                1
            ]
        },
        {
            "name": "Mr. Tracy Clark PhD",
            "city": 0,
            "color": "blue",
            "qualifications": [
                4,
                1,
                1,
                5
            ]
        },
        {
            "name": "Matthew Perry",
            "city": 0,
            "color": "blue",
            "qualifications": [
                0,
                5,
                8,
                0
            ]
        },
        {
            "name": "William Osborne",
            "city": 1,
            "color": "orange",
            "qualifications": [
                8,
                7,
                6,
                8
            ]
        },
        {
            "name": "Ashley Miller",
            "city": 1,
            "color": "orange",
            "qualifications": [
                1,
                1,
                1,
                4
            ]
        },
        {
            "name": "Brandy Smith",
            "city": 0,
            "color": "blue",
            "qualifications": [
                3,
                7,
                8,
                6
            ]
        },
        {
            "name": "Lauren Bowers",
            "city": 1,
            "color": "orange",
            "qualifications": [
                4,
                3,
                7,
                3
            ]
        },
        {
            "name": "Michelle Hernandez",
            "city": 1,
            "color": "orange",
            "qualifications": [
                8,
                1,
                0,
                5
            ]
        },
        {
            "name": "Ruben Hughes",
            "city": 0,
            "color": "blue",
            "qualifications": [
                2,
                1,
                3,
                9
            ]
        },
        {
            "name": "Elijah Pittman",
            "city": 0,
            "color": "blue",
            "qualifications": [
                2,
                5,
                2,
                2
            ]
        },
        {
            "name": "Gerald Krause",
            "city": 0,
            "color": "blue",
            "qualifications": [
                2,
                1,
                0,
                3
            ]
        },
        {
            "name": "Michelle Cox",
            "city": 1,
            "color": "orange",
            "qualifications": [
                5,
                7,
                3,
                6
            ]
        },
        {
            "name": "Rebecca Ellis",
            "city": 0,
            "color": "blue",
            "qualifications": [
                3,
                3,
                0,
                2
            ]
        },
        {
            "name": "Lisa Smith",
            "city": 0,
            "color": "blue",
            "qualifications": [
                7,
                9,
                3,
                8
            ]
        },
        {
            "name": "Joel Young",
            "city": 0,
            "color": "blue",
            "qualifications": [
                0,
                3,
                4,
                6
            ]
        },
        {
            "name": "Lawrence Simpson",
            "city": 1,
            "color": "orange",
            "qualifications": [
                3,
                6,
                7,
                0
            ]
        },
        {
            "name": "Daniel Elliott",
            "city": 0,
            "color": "blue",
            "qualifications": [
                7,
                3,
                3,
                5
            ]
        },
        {
            "name": "Ryan Johnson",
            "city": 0,
            "color": "blue",
            "qualifications": [
                0,
                3,
                9,
                2
            ]
        },
        {
            "name": "Kenneth Sandoval",
            "city": 0,
            "color": "blue",
            "qualifications": [
                5,
                7,
                5,
                9
            ]
        },
        {
            "name": "Kimberly Sullivan",
            "city": 0,
            "color": "blue",
            "qualifications": [
                7,
                0,
                4,
                7
            ]
        },
        {
            "name": "David Cooper",
            "city": 0,
            "color": "blue",
            "qualifications": [
                5,
                5,
                1,
                9
            ]
        },
        {
            "name": "Joshua Robinson",
            "city": 1,
            "color": "orange",
            "qualifications": [
                0,
                7,
                8,
                0
            ]
        },
        {
            "name": "Taylor Bennett",
            "city": 0,
            "color": "blue",
            "qualifications": [
                8,
                2,
                9,
                5
            ]
        },
        {
            "name": "David White",
            "city": 1,
            "color": "orange",
            "qualifications": [
                3,
                3,
                1,
                5
            ]
        },
        {
            "name": "Linda Price",
            "city": 1,
            "color": "orange",
            "qualifications": [
                4,
                5,
                8,
                0
            ]
        },
        {
            "name": "Walter Rodriguez",
            "city": 1,
            "color": "orange",
            "qualifications": [
                3,
                4,
                5,
                6
            ]
        },
        {
            "name": "Richard Adams",
            "city": 0,
            "color": "blue",
            "qualifications": [
                6,
                5,
                8,
                7
            ]
        },
        {
            "name": "Maria Smith",
            "city": 0,
            "color": "blue",
            "qualifications": [
                9,
                6,
                4,
                6
            ]
        },
        {
            "name": "Erin Hahn",
            "city": 1,
            "color": "orange",
            "qualifications": [
                3,
                3,
                8,
                6
            ]
        },
        {
            "name": "Kim Hughes",
            "city": 0,
            "color": "blue",
            "qualifications": [
                3,
                0,
                2,
                2
            ]
        },
        {
            "name": "Carly Macdonald",
            "city": 0,
            "color": "blue",
            "qualifications": [
                4,
                8,
                2,
                3
            ]
        },
        {
            "name": "James Thomas",
            "city": 0,
            "color": "blue",
            "qualifications": [
                2,
                8,
                4,
                7
            ]
        },
        {
            "name": "Jim Doyle",
            "city": 0,
            "color": "blue",
            "qualifications": [
                4,
                6,
                1,
                1
            ]
        },
        {
            "name": "Susan Moore",
            "city": 0,
            "color": "blue",
            "qualifications": [
                2,
                6,
                3,
                9
            ]
        },
        {
            "name": "Carolyn Cortez",
            "city": 0,
            "color": "blue",
            "qualifications": [
                9,
                5,
                3,
                2
            ]
        },
        {
            "name": "Laurie Harris",
            "city": 0,
            "color": "blue",
            "qualifications": [
                2,
                0,
                3,
                1
            ]
        },
        {
            "name": "Austin Greer",
            "city": 0,
            "color": "blue",
            "qualifications": [
                9,
                1,
                7,
                7
            ]
        },
        {
            "name": "Crystal Perez",
            "city": 0,
            "color": "blue",
            "qualifications": [
                3,
                3,
                2,
                5
            ]
        },
        {
            "name": "Theresa Smith",
            "city": 0,
            "color": "blue",
            "qualifications": [
                7,
                3,
                6,
                6
            ]
        },
        {
            "name": "Randy Snyder",
            "city": 1,
            "color": "orange",
            "qualifications": [
                3,
                2,
                5,
                9
            ]
        },
        {
            "name": "Lindsay Wilson",
            "city": 1,
            "color": "orange",
            "qualifications": [
                5,
                4,
                8,
                6
            ]
        },
        {
            "name": "Stephen Smith Jr.",
            "city": 0,
            "color": "blue",
            "qualifications": [
                5,
                2,
                5,
                8
            ]
        },
        {
            "name": "Luis Smith",
            "city": 1,
            "color": "orange",
            "qualifications": [
                5,
                9,
                3,
                6
            ]
        },
        {
            "name": "Tammy Haynes",
            "city": 0,
            "color": "blue",
            "qualifications": [
                2,
                0,
                8,
                0
            ]
        },
        {
            "name": "Jeff Thomas",
            "city": 1,
            "color": "orange",
            "qualifications": [
                7,
                5,
                0,
                5
            ]
        },
        {
            "name": "Jamie Stephens",
            "city": 0,
            "color": "blue",
            "qualifications": [
                1,
                0,
                5,
                7
            ]
        },
        {
            "name": "Donald Olsen",
            "city": 1,
            "color": "orange",
            "qualifications": [
                1,
                5,
                6,
                2
            ]
        },
        {
            "name": "Mr. Thomas Lawson",
            "city": 1,
            "color": "orange",
            "qualifications": [
                0,
                7,
                0,
                1
            ]
        },
        {
            "name": "Cynthia Jackson",
            "city": 1,
            "color": "orange",
            "qualifications": [
                7,
                5,
                9,
                2
            ]
        },
        {
            "name": "Lauren Hoffman",
            "city": 1,
            "color": "blue",
            "qualifications": [
                1,
                8,
                4,
                3
            ]
        },
        {
            "name": "Gary Le",
            "city": 0,
            "color": "blue",
            "qualifications": [
                6,
                8,
                9,
                4
            ]
        },
        {
            "name": "Kimberly Calhoun",
            "city": 1,
            "color": "orange",
            "qualifications": [
                6,
                0,
                4,
                1
            ]
        },
        {
            "name": "Elizabeth Larson",
            "city": 0,
            "color": "blue",
            "qualifications": [
                9,
                9,
                0,
                1
            ]
        },
        {
            "name": "Robert Miller",
            "city": 1,
            "color": "orange",
            "qualifications": [
                1,
                1,
                3,
                8
            ]
        },
        {
            "name": "Frances Luna DVM",
            "city": 0,
            "color": "blue",
            "qualifications": [
                3,
                9,
                5,
                4
            ]
        },
        {
            "name": "Michael Jones",
            "city": 1,
            "color": "orange",
            "qualifications": [
                1,
                7,
                8,
                8
            ]
        },
        {
            "name": "Karen Howard",
            "city": 0,
            "color": "blue",
            "qualifications": [
                1,
                9,
                2,
                2
            ]
        },
        {
            "name": "Daniel Parker",
            "city": 1,
            "color": "orange",
            "qualifications": [
                5,
                4,
                3,
                8
            ]
        },
        {
            "name": "Rodney Bryan",
            "city": 1,
            "color": "orange",
            "qualifications": [
                4,
                9,
                3,
                5
            ]
        },
        {
            "name": "Eric Shea",
            "city": 1,
            "color": "orange",
            "qualifications": [
                8,
                8,
                9,
                1
            ]
        },
        {
            "name": "Amanda Lopez",
            "city": 0,
            "color": "blue",
            "qualifications": [
                5,
                3,
                0,
                3
            ]
        },
        {
            "name": "Jennifer Herrera",
            "city": 0,
            "color": "blue",
            "qualifications": [
                2,
                8,
                3,
                7
            ]
        },
        {
            "name": "Julia Gregory",
            "city": 0,
            "color": "blue",
            "qualifications": [
                5,
                6,
                7,
                7
            ]
        },
        {
            "name": "Alexis Edwards",
            "city": 0,
            "color": "blue",
            "qualifications": [
                5,
                5,
                5,
                7
            ]
        },
        {
            "name": "Alexandra Hernandez",
            "city": 0,
            "color": "blue",
            "qualifications": [
                2,
                8,
                5,
                8
            ]
        },
        {
            "name": "Patricia Johnson",
            "city": 0,
            "color": "blue",
            "qualifications": [
                6,
                0,
                1,
                7
            ]
        },
        {
            "name": "Sean Ward",
            "city": 0,
            "color": "blue",
            "qualifications": [
                3,
                5,
                9,
                9
            ]
        },
        {
            "name": "Sarah Long",
            "city": 0,
            "color": "blue",
            "qualifications": [
                4,
                6,
                6,
                4
            ]
        },
        {
            "name": "Zachary Johns",
            "city": 1,
            "color": "orange",
            "qualifications": [
                0,
                8,
                2,
                7
            ]
        },
        {
            "name": "Tracy Mclaughlin",
            "city": 1,
            "color": "orange",
            "qualifications": [
                9,
                3,
                1,
                6
            ]
        },
        {
            "name": "Wanda Miller",
            "city": 0,
            "color": "blue",
            "qualifications": [
                7,
                1,
                4,
                4
            ]
        },
        {
            "name": "Danielle Johnson",
            "city": 0,
            "color": "blue",
            "qualifications": [
                4,
                4,
                4,
                5
            ]
        },
        {
            "name": "Alexander Johnson",
            "city": 1,
            "color": "orange",
            "qualifications": [
                1,
                4,
                3,
                8
            ]
        },
        {
            "name": "Christopher Carter",
            "city": 1,
            "color": "orange",
            "qualifications": [
                3,
                8,
                8,
                4
            ]
        },
        {
            "name": "Melinda Weber",
            "city": 0,
            "color": "blue",
            "qualifications": [
                4,
                2,
                0,
                4
            ]
        },
        {
            "name": "Kristina Ward",
            "city": 1,
            "color": "orange",
            "qualifications": [
                4,
                6,
                4,
                5
            ]
        },
        {
            "name": "Denise Love",
            "city": 1,
            "color": "orange",
            "qualifications": [
                3,
                4,
                9,
                5
            ]
        },
        {
            "name": "David Garrett",
            "city": 1,
            "color": "orange",
            "qualifications": [
                7,
                6,
                9,
                5
            ]
        },
        {
            "name": "James Hunt",
            "city": 1,
            "color": "orange",
            "qualifications": [
                3,
                7,
                6,
                8
            ]
        },
        {
            "name": "Jesus Myers",
            "city": 0,
            "color": "blue",
            "qualifications": [
                5,
                8,
                9,
                2
            ]
        },
        {
            "name": "Christopher Colon",
            "city": 0,
            "color": "blue",
            "qualifications": [
                5,
                5,
                8,
                2
            ]
        },
        {
            "name": "Zachary Webster",
            "city": 1,
            "color": "orange",
            "qualifications": [
                0,
                9,
                8,
                0
            ]
        },
        {
            "name": "Mikayla Salazar",
            "city": 1,
            "color": "orange",
            "qualifications": [
                2,
                4,
                3,
                4
            ]
        },
        {
            "name": "Christopher Costa",
            "city": 0,
            "color": "blue",
            "qualifications": [
                9,
                5,
                2,
                1
            ]
        },
        {
            "name": "Tasha Reeves",
            "city": 0,
            "color": "blue",
            "qualifications": [
                5,
                0,
                7,
                7
            ]
        },
        {
            "name": "James Scott",
            "city": 0,
            "color": "blue",
            "qualifications": [
                6,
                8,
                1,
                7
            ]
        },
        {
            "name": "Jodi Martinez",
            "city": 1,
            "color": "orange",
            "qualifications": [
                2,
                3,
                4,
                6
            ]
        },
        {
            "name": "James Hall",
            "city": 1,
            "color": "orange",
            "qualifications": [
                0,
                3,
                6,
                7
            ]
        },
        {
            "name": "Scott Martinez",
            "city": 0,
            "color": "blue",
            "qualifications": [
                9,
                3,
                8,
                1
            ]
        },
        {
            "name": "Debra Anderson",
            "city": 0,
            "color": "blue",
            "qualifications": [
                4,
                9,
                2,
                5
            ]
        },
        {
            "name": "Jeremiah Pacheco",
            "city": 0,
            "color": "blue",
            "qualifications": [
                1,
                2,
                4,
                9
            ]
        },
        {
            "name": "Alicia Fischer",
            "city": 1,
            "color": "orange",
            "qualifications": [
                5,
                6,
                8,
                4
            ]
        },
        {
            "name": "Trevor Smith",
            "city": 0,
            "color": "blue",
            "qualifications": [
                4,
                6,
                3,
                7
            ]
        },
        {
            "name": "Jamie Shaw",
            "city": 0,
            "color": "blue",
            "qualifications": [
                2,
                0,
                6,
                2
            ]
        },
        {
            "name": "Matthew Henderson",
            "city": 1,
            "color": "orange",
            "qualifications": [
                0,
                9,
                4,
                2
            ]
        },
        {
            "name": "Lauren Harris",
            "city": 0,
            "color": "blue",
            "qualifications": [
                8,
                8,
                6,
                8
            ]
        },
        {
            "name": "Brendan White",
            "city": 0,
            "color": "blue",
            "qualifications": [
                3,
                0,
                0,
                7
            ]
        },
        {
            "name": "Anthony Jackson",
            "city": 1,
            "color": "orange",
            "qualifications": [
                3,
                5,
                5,
                0
            ]
        },
        {
            "name": "Lisa Morgan DDS",
            "city": 0,
            "color": "blue",
            "qualifications": [
                3,
                8,
                4,
                1
            ]
        },
        {
            "name": "Charles Hartman",
            "city": 1,
            "color": "orange",
            "qualifications": [
                3,
                5,
                8,
                7
            ]
        },
        {
            "name": "Heather Juarez",
            "city": 1,
            "color": "orange",
            "qualifications": [
                4,
                8,
                4,
                9
            ]
        },
        {
            "name": "Stephanie Reed",
            "city": 1,
            "color": "orange",
            "qualifications": [
                5,
                6,
                2,
                0
            ]
        },
        {
            "name": "Carolyn Dunlap",
            "city": 0,
            "color": "blue",
            "qualifications": [
                4,
                5,
                1,
                6
            ]
        },
        {
            "name": "Michelle Rodriguez",
            "city": 0,
            "color": "blue",
            "qualifications": [
                6,
                4,
                1,
                9
            ]
        },
        {
            "name": "John Allen",
            "city": 0,
            "color": "blue",
            "qualifications": [
                1,
                4,
                8,
                4
            ]
        },
        {
            "name": "Roy Stokes",
            "city": 1,
            "color": "orange",
            "qualifications": [
                8,
                9,
                8,
                3
            ]
        },
        {
            "name": "Anthony Boone",
            "city": 1,
            "color": "orange",
            "qualifications": [
                8,
                7,
                6,
                6
            ]
        },
        {
            "name": "Michael Norman",
            "city": 0,
            "color": "blue",
            "qualifications": [
                4,
                5,
                8,
                0
            ]
        },
        {
            "name": "Blake Bonilla",
            "city": 1,
            "color": "orange",
            "qualifications": [
                4,
                2,
                5,
                0
            ]
        },
        {
            "name": "Lucas Johnson",
            "city": 1,
            "color": "orange",
            "qualifications": [
                2,
                4,
                7,
                2
            ]
        },
        {
            "name": "Carlos Ramos",
            "city": 1,
            "color": "orange",
            "qualifications": [
                9,
                2,
                6,
                2
            ]
        },
        {
            "name": "Andrea Dudley",
            "city": 0,
            "color": "blue",
            "qualifications": [
                2,
                8,
                9,
                2
            ]
        },
        {
            "name": "Carl Lopez",
            "city": 0,
            "color": "blue",
            "qualifications": [
                8,
                0,
                7,
                3
            ]
        },
        {
            "name": "Tracey Diaz",
            "city": 1,
            "color": "orange",
            "qualifications": [
                2,
                0,
                1,
                7
            ]
        },
        {
            "name": "Lacey Strickland",
            "city": 1,
            "color": "orange",
            "qualifications": [
                0,
                2,
                8,
                0
            ]
        },
        {
            "name": "William James",
            "city": 1,
            "color": "orange",
            "qualifications": [
                1,
                4,
                0,
                1
            ]
        },
        {
            "name": "Jasmine Johnson",
            "city": 0,
            "color": "blue",
            "qualifications": [
                3,
                3,
                1,
                5
            ]
        },
        {
            "name": "Christina Richardson",
            "city": 1,
            "color": "orange",
            "qualifications": [
                0,
                0,
                6,
                6
            ]
        },
        {
            "name": "Brianna Rivera",
            "city": 0,
            "color": "blue",
            "qualifications": [
                5,
                6,
                8,
                5
            ]
        },
        {
            "name": "Benjamin Wolfe",
            "city": 0,
            "color": "blue",
            "qualifications": [
                5,
                2,
                5,
                1
            ]
        },
        {
            "name": "Wanda Mccarthy",
            "city": 1,
            "color": "orange",
            "qualifications": [
                0,
                8,
                1,
                5
            ]
        },
        {
            "name": "Gregory Meza",
            "city": 1,
            "color": "orange",
            "qualifications": [
                0,
                5,
                2,
                7
            ]
        },
        {
            "name": "Denise Dunn",
            "city": 0,
            "color": "blue",
            "qualifications": [
                7,
                4,
                4,
                2
            ]
        },
        {
            "name": "Donna Wolf",
            "city": 0,
            "color": "blue",
            "qualifications": [
                0,
                1,
                2,
                7
            ]
        },
        {
            "name": "Gregory Yoder",
            "city": 1,
            "color": "orange",
            "qualifications": [
                4,
                6,
                9,
                3
            ]
        },
        {
            "name": "Cassidy Graham",
            "city": 0,
            "color": "blue",
            "qualifications": [
                5,
                4,
                2,
                6
            ]
        },
        {
            "name": "Brooke Jordan",
            "city": 1,
            "color": "orange",
            "qualifications": [
                7,
                0,
                8,
                1
            ]
        },
        {
            "name": "Cheryl West",
            "city": 0,
            "color": "blue",
            "qualifications": [
                0,
                4,
                4,
                9
            ]
        },
        {
            "name": "Benjamin Jenkins",
            "city": 0,
            "color": "blue",
            "qualifications": [
                5,
                5,
                5,
                5
            ]
        },
        {
            "name": "Dylan King",
            "city": 0,
            "color": "blue",
            "qualifications": [
                6,
                7,
                7,
                4
            ]
        },
        {
            "name": "Terry Austin",
            "city": 0,
            "color": "blue",
            "qualifications": [
                2,
                0,
                3,
                6
            ]
        },
        {
            "name": "Vanessa Francis",
            "city": 0,
            "color": "blue",
            "qualifications": [
                0,
                4,
                8,
                5
            ]
        },
        {
            "name": "Samantha Carpenter",
            "city": 0,
            "color": "blue",
            "qualifications": [
                1,
                4,
                3,
                7
            ]
        },
        {
            "name": "Teresa Lee",
            "city": 0,
            "color": "blue",
            "qualifications": [
                8,
                3,
                0,
                4
            ]
        },
        {
            "name": "Beth Wallace",
            "city": 1,
            "color": "orange",
            "qualifications": [
                5,
                1,
                4,
                5
            ]
        },
        {
            "name": "Calvin Gonzalez",
            "city": 1,
            "color": "orange",
            "qualifications": [
                6,
                6,
                2,
                9
            ]
        },
        {
            "name": "Ethan Martin",
            "city": 0,
            "color": "blue",
            "qualifications": [
                5,
                1,
                7,
                4
            ]
        },
        {
            "name": "Olivia Stevens",
            "city": 0,
            "color": "blue",
            "qualifications": [
                4,
                9,
                3,
                3
            ]
        },
        {
            "name": "Trevor Harrison",
            "city": 0,
            "color": "blue",
            "qualifications": [
                1,
                4,
                7,
                6
            ]
        },
        {
            "name": "Andrew Lee",
            "city": 0,
            "color": "blue",
            "qualifications": [
                8,
                6,
                6,
                0
            ]
        },
        {
            "name": "Christopher Ross II",
            "city": 0,
            "color": "blue",
            "qualifications": [
                5,
                0,
                9,
                3
            ]
        },
        {
            "name": "Robert Sutton Jr.",
            "city": 0,
            "color": "blue",
            "qualifications": [
                4,
                0,
                4,
                4
            ]
        },
        {
            "name": "Melvin Wilson",
            "city": 0,
            "color": "blue",
            "qualifications": [
                7,
                9,
                5,
                3
            ]
        },
        {
            "name": "Karen Bullock",
            "city": 0,
            "color": "blue",
            "qualifications": [
                4,
                1,
                0,
                3
            ]
        },
        {
            "name": "Amanda Walker",
            "city": 0,
            "color": "blue",
            "qualifications": [
                4,
                3,
                1,
                5
            ]
        },
        {
            "name": "Guy Scott",
            "city": 1,
            "color": "orange",
            "qualifications": [
                2,
                9,
                1,
                1
            ]
        },
        {
            "name": "Manuel Fleming",
            "city": 1,
            "color": "orange",
            "qualifications": [
                0,
                1,
                1,
                9
            ]
        },
        {
            "name": "David Phelps",
            "city": 0,
            "color": "blue",
            "qualifications": [
                6,
                3,
                8,
                5
            ]
        },
        {
            "name": "Peter Green",
            "city": 0,
            "color": "blue",
            "qualifications": [
                6,
                2,
                5,
                2
            ]
        },
        {
            "name": "James Sanchez",
            "city": 1,
            "color": "orange",
            "qualifications": [
                2,
                6,
                5,
                9
            ]
        },
        {
            "name": "Lee Stephenson",
            "city": 1,
            "color": "orange",
            "qualifications": [
                6,
                9,
                4,
                2
            ]
        },
        {
            "name": "Erica Bowman",
            "city": 0,
            "color": "blue",
            "qualifications": [
                1,
                9,
                1,
                3
            ]
        },
        {
            "name": "Mark Lee",
            "city": 0,
            "color": "blue",
            "qualifications": [
                9,
                4,
                3,
                3
            ]
        },
        {
            "name": "Zachary Brooks",
            "city": 1,
            "color": "blue",
            "qualifications": [
                1,
                5,
                6,
                9
            ]
        },
        {
            "name": "Ronald Santos",
            "city": 1,
            "color": "orange",
            "qualifications": [
                2,
                4,
                7,
                9
            ]
        },
        {
            "name": "Richard Robinson",
            "city": 1,
            "color": "orange",
            "qualifications": [
                2,
                6,
                3,
                0
            ]
        },
        {
            "name": "Fred Pierce",
            "city": 0,
            "color": "blue",
            "qualifications": [
                4,
                1,
                9,
                9
            ]
        },
        {
            "name": "Michael Rose",
            "city": 0,
            "color": "blue",
            "qualifications": [
                0,
                6,
                3,
                6
            ]
        },
        {
            "name": "Christina Day",
            "city": 1,
            "color": "orange",
            "qualifications": [
                4,
                5,
                9,
                8
            ]
        },
        {
            "name": "Mark Riley",
            "city": 0,
            "color": "blue",
            "qualifications": [
                2,
                0,
                3,
                4
            ]
        },
        {
            "name": "Suzanne Booker",
            "city": 0,
            "color": "blue",
            "qualifications": [
                6,
                3,
                4,
                7
            ]
        },
        {
            "name": "Ellen Zavala",
            "city": 0,
            "color": "blue",
            "qualifications": [
                2,
                8,
                5,
                2
            ]
        },
        {
            "name": "Ashley Silva",
            "city": 1,
            "color": "orange",
            "qualifications": [
                6,
                5,
                6,
                5
            ]
        },
        {
            "name": "Tyler Oconnor",
            "city": 1,
            "color": "orange",
            "qualifications": [
                9,
                0,
                2,
                4
            ]
        },
        {
            "name": "Mary Sparks",
            "city": 1,
            "color": "orange",
            "qualifications": [
                6,
                2,
                5,
                5
            ]
        },
        {
            "name": "Sharon Santos",
            "city": 1,
            "color": "orange",
            "qualifications": [
                2,
                0,
                5,
                5
            ]
        },
        {
            "name": "Heidi Campbell",
            "city": 1,
            "color": "orange",
            "qualifications": [
                9,
                7,
                0,
                9
            ]
        },
        {
            "name": "Andrew Munoz",
            "city": 0,
            "color": "blue",
            "qualifications": [
                7,
                5,
                5,
                0
            ]
        },
        {
            "name": "John Brown",
            "city": 0,
            "color": "blue",
            "qualifications": [
                1,
                5,
                7,
                5
            ]
        },
        {
            "name": "Michelle Walker",
            "city": 0,
            "color": "blue",
            "qualifications": [
                6,
                2,
                0,
                8
            ]
        },
        {
            "name": "Laura Case",
            "city": 0,
            "color": "blue",
            "qualifications": [
                8,
                9,
                3,
                1
            ]
        },
        {
            "name": "Erica Ashley",
            "city": 0,
            "color": "blue",
            "qualifications": [
                0,
                6,
                6,
                9
            ]
        },
        {
            "name": "Donald Lyons",
            "city": 0,
            "color": "blue",
            "qualifications": [
                0,
                3,
                3,
                2
            ]
        },
        {
            "name": "Jillian Munoz",
            "city": 0,
            "color": "blue",
            "qualifications": [
                4,
                3,
                5,
                0
            ]
        },
        {
            "name": "Molly Graham",
            "city": 1,
            "color": "orange",
            "qualifications": [
                9,
                7,
                7,
                7
            ]
        },
        {
            "name": "Christopher Williams",
            "city": 1,
            "color": "orange",
            "qualifications": [
                3,
                4,
                0,
                0
            ]
        },
        {
            "name": "Jordan Elliott",
            "city": 1,
            "color": "orange",
            "qualifications": [
                6,
                1,
                3,
                4
            ]
        },
        {
            "name": "Tiffany Copeland",
            "city": 0,
            "color": "blue",
            "qualifications": [
                2,
                9,
                0,
                5
            ]
        },
        {
            "name": "Desiree Singleton",
            "city": 1,
            "color": "orange",
            "qualifications": [
                0,
                1,
                1,
                2
            ]
        },
        {
            "name": "Deborah Leonard",
            "city": 1,
            "color": "orange",
            "qualifications": [
                3,
                4,
                5,
                5
            ]
        },
        {
            "name": "Amanda Henderson",
            "city": 0,
            "color": "blue",
            "qualifications": [
                4,
                6,
                6,
                6
            ]
        },
        {
            "name": "Erica Yang",
            "city": 0,
            "color": "blue",
            "qualifications": [
                0,
                6,
                9,
                3
            ]
        },
        {
            "name": "Tyler Cook",
            "city": 0,
            "color": "blue",
            "qualifications": [
                4,
                7,
                8,
                3
            ]
        },
        {
            "name": "Melanie Lopez",
            "city": 0,
            "color": "blue",
            "qualifications": [
                2,
                6,
                2,
                4
            ]
        },
        {
            "name": "Pamela King",
            "city": 0,
            "color": "blue",
            "qualifications": [
                7,
                1,
                8,
                8
            ]
        },
        {
            "name": "Nicholas Scott",
            "city": 1,
            "color": "orange",
            "qualifications": [
                0,
                3,
                4,
                4
            ]
        },
        {
            "name": "Daniel Cummings",
            "city": 1,
            "color": "orange",
            "qualifications": [
                0,
                7,
                9,
                7
            ]
        },
        {
            "name": "Brittany Williams",
            "city": 0,
            "color": "blue",
            "qualifications": [
                8,
                1,
                5,
                3
            ]
        },
        {
            "name": "Mrs. Amanda Shah MD",
            "city": 1,
            "color": "orange",
            "qualifications": [
                7,
                5,
                6,
                4
            ]
        },
        {
            "name": "Sandy Parsons",
            "city": 1,
            "color": "orange",
            "qualifications": [
                4,
                3,
                1,
                5
            ]
        },
        {
            "name": "Jennifer Sanchez",
            "city": 1,
            "color": "orange",
            "qualifications": [
                1,
                7,
                3,
                8
            ]
        },
        {
            "name": "Jeffrey Price",
            "city": 0,
            "color": "blue",
            "qualifications": [
                7,
                7,
                4,
                8
            ]
        },
        {
            "name": "Matthew Henderson",
            "city": 0,
            "color": "blue",
            "qualifications": [
                2,
                9,
                7,
                8
            ]
        },
        {
            "name": "Timothy Barnett",
            "city": 0,
            "color": "blue",
            "qualifications": [
                0,
                2,
                0,
                7
            ]
        },
        {
            "name": "James White",
            "city": 0,
            "color": "blue",
            "qualifications": [
                2,
                4,
                2,
                0
            ]
        },
        {
            "name": "Elizabeth Sanchez",
            "city": 0,
            "color": "blue",
            "qualifications": [
                8,
                9,
                6,
                0
            ]
        },
        {
            "name": "Pamela Griffith",
            "city": 0,
            "color": "blue",
            "qualifications": [
                0,
                5,
                5,
                0
            ]
        },
        {
            "name": "Richard Hawkins",
            "city": 1,
            "color": "orange",
            "qualifications": [
                0,
                0,
                3,
                5
            ]
        },
        {
            "name": "Barbara West",
            "city": 0,
            "color": "blue",
            "qualifications": [
                7,
                3,
                3,
                3
            ]
        },
        {
            "name": "Gregory Cooper",
            "city": 1,
            "color": "orange",
            "qualifications": [
                5,
                1,
                2,
                1
            ]
        },
        {
            "name": "Matthew Morris",
            "city": 1,
            "color": "orange",
            "qualifications": [
                8,
                1,
                9,
                8
            ]
        },
        {
            "name": "Amber Fisher",
            "city": 1,
            "color": "orange",
            "qualifications": [
                7,
                2,
                9,
                5
            ]
        },
        {
            "name": "Lisa Barnes",
            "city": 0,
            "color": "blue",
            "qualifications": [
                6,
                2,
                4,
                9
            ]
        },
        {
            "name": "Wendy Ryan",
            "city": 0,
            "color": "blue",
            "qualifications": [
                5,
                5,
                0,
                2
            ]
        },
        {
            "name": "Maria Ortiz",
            "city": 1,
            "color": "orange",
            "qualifications": [
                4,
                1,
                6,
                2
            ]
        },
        {
            "name": "Molly Jackson",
            "city": 1,
            "color": "orange",
            "qualifications": [
                6,
                8,
                2,
                4
            ]
        },
        {
            "name": "Timothy Williams",
            "city": 0,
            "color": "blue",
            "qualifications": [
                3,
                7,
                0,
                6
            ]
        },
        {
            "name": "Carol Mckinney",
            "city": 0,
            "color": "blue",
            "qualifications": [
                2,
                0,
                1,
                4
            ]
        },
        {
            "name": "Debbie Burnett",
            "city": 1,
            "color": "orange",
            "qualifications": [
                0,
                0,
                2,
                5
            ]
        },
        {
            "name": "Wendy Perkins",
            "city": 1,
            "color": "blue",
            "qualifications": [
                5,
                0,
                0,
                8
            ]
        },
        {
            "name": "Jason Ortiz",
            "city": 0,
            "color": "blue",
            "qualifications": [
                4,
                5,
                9,
                3
            ]
        },
        {
            "name": "Amanda Clark",
            "city": 1,
            "color": "orange",
            "qualifications": [
                9,
                0,
                9,
                4
            ]
        },
        {
            "name": "Jason Summers",
            "city": 1,
            "color": "orange",
            "qualifications": [
                3,
                7,
                4,
                1
            ]
        },
        {
            "name": "David Davidson",
            "city": 1,
            "color": "orange",
            "qualifications": [
                5,
                5,
                3,
                3
            ]
        },
        {
            "name": "Emily Jackson",
            "city": 0,
            "color": "blue",
            "qualifications": [
                9,
                4,
                6,
                0
            ]
        },
        {
            "name": "Emily Wu",
            "city": 1,
            "color": "orange",
            "qualifications": [
                0,
                4,
                4,
                1
            ]
        },
        {
            "name": "Chad Carter",
            "city": 1,
            "color": "orange",
            "qualifications": [
                1,
                8,
                4,
                8
            ]
        },
        {
            "name": "Cameron Estes",
            "city": 1,
            "color": "orange",
            "qualifications": [
                8,
                6,
                7,
                2
            ]
        },
        {
            "name": "Kristina Rogers",
            "city": 0,
            "color": "blue",
            "qualifications": [
                0,
                6,
                5,
                1
            ]
        },
        {
            "name": "Tina Lewis",
            "city": 1,
            "color": "orange",
            "qualifications": [
                4,
                7,
                9,
                8
            ]
        },
        {
            "name": "Brian James",
            "city": 0,
            "color": "blue",
            "qualifications": [
                0,
                4,
                3,
                0
            ]
        },
        {
            "name": "Samantha Conner",
            "city": 0,
            "color": "blue",
            "qualifications": [
                0,
                7,
                5,
                6
            ]
        },
        {
            "name": "Jose Garcia",
            "city": 1,
            "color": "orange",
            "qualifications": [
                0,
                6,
                4,
                6
            ]
        },
        {
            "name": "Manuel Perry",
            "city": 1,
            "color": "orange",
            "qualifications": [
                4,
                3,
                7,
                6
            ]
        },
        {
            "name": "Willie Maldonado",
            "city": 1,
            "color": "orange",
            "qualifications": [
                4,
                4,
                2,
                6
            ]
        },
        {
            "name": "Debra Wiley",
            "city": 1,
            "color": "orange",
            "qualifications": [
                5,
                5,
                6,
                0
            ]
        },
        {
            "name": "Sara Rich",
            "city": 1,
            "color": "orange",
            "qualifications": [
                5,
                9,
                6,
                5
            ]
        },
        {
            "name": "Kyle Johnston",
            "city": 1,
            "color": "orange",
            "qualifications": [
                6,
                6,
                4,
                9
            ]
        },
        {
            "name": "Daniel Reilly",
            "city": 1,
            "color": "orange",
            "qualifications": [
                8,
                7,
                8,
                9
            ]
        },
        {
            "name": "Samantha Garcia",
            "city": 0,
            "color": "blue",
            "qualifications": [
                8,
                5,
                2,
                0
            ]
        },
        {
            "name": "Heidi Williams",
            "city": 0,
            "color": "blue",
            "qualifications": [
                3,
                3,
                0,
                0
            ]
        },
        {
            "name": "Misty Porter",
            "city": 1,
            "color": "orange",
            "qualifications": [
                2,
                8,
                8,
                3
            ]
        },
        {
            "name": "Krista Griffin",
            "city": 0,
            "color": "blue",
            "qualifications": [
                2,
                7,
                4,
                1
            ]
        },
        {
            "name": "Sherri Clark",
            "city": 1,
            "color": "orange",
            "qualifications": [
                7,
                0,
                0,
                4
            ]
        },
        {
            "name": "Marie Martinez",
            "city": 0,
            "color": "blue",
            "qualifications": [
                9,
                8,
                0,
                3
            ]
        },
        {
            "name": "David Miller",
            "city": 0,
            "color": "blue",
            "qualifications": [
                0,
                3,
                9,
                2
            ]
        },
        {
            "name": "Rachel Marsh",
            "city": 0,
            "color": "blue",
            "qualifications": [
                0,
                7,
                0,
                3
            ]
        },
        {
            "name": "Richard Copeland",
            "city": 0,
            "color": "blue",
            "qualifications": [
                0,
                9,
                9,
                7
            ]
        },
        {
            "name": "Vanessa Carter",
            "city": 0,
            "color": "blue",
            "qualifications": [
                7,
                8,
                5,
                6
            ]
        },
        {
            "name": "Joy Malone",
            "city": 0,
            "color": "blue",
            "qualifications": [
                7,
                4,
                0,
                8
            ]
        },
        {
            "name": "James Pace",
            "city": 0,
            "color": "blue",
            "qualifications": [
                8,
                5,
                6,
                1
            ]
        },
        {
            "name": "Paul Shannon",
            "city": 0,
            "color": "blue",
            "qualifications": [
                7,
                0,
                5,
                4
            ]
        },
        {
            "name": "Derrick Cordova",
            "city": 0,
            "color": "blue",
            "qualifications": [
                4,
                7,
                7,
                8
            ]
        },
        {
            "name": "Ryan Mcgee",
            "city": 1,
            "color": "orange",
            "qualifications": [
                4,
                1,
                6,
                2
            ]
        },
        {
            "name": "Kaitlyn Fisher",
            "city": 1,
            "color": "orange",
            "qualifications": [
                0,
                6,
                2,
                4
            ]
        },
        {
            "name": "David Skinner",
            "city": 0,
            "color": "blue",
            "qualifications": [
                9,
                8,
                9,
                2
            ]
        },
        {
            "name": "Whitney Johnson",
            "city": 1,
            "color": "orange",
            "qualifications": [
                0,
                1,
                1,
                5
            ]
        },
        {
            "name": "David Nelson",
            "city": 0,
            "color": "blue",
            "qualifications": [
                8,
                4,
                3,
                8
            ]
        },
        {
            "name": "Christopher Stafford",
            "city": 0,
            "color": "blue",
            "qualifications": [
                8,
                3,
                3,
                3
            ]
        },
        {
            "name": "Steven Wilson",
            "city": 1,
            "color": "orange",
            "qualifications": [
                7,
                3,
                2,
                2
            ]
        },
        {
            "name": "Lance Lee",
            "city": 0,
            "color": "blue",
            "qualifications": [
                1,
                9,
                5,
                0
            ]
        },
        {
            "name": "Benjamin Jones",
            "city": 0,
            "color": "blue",
            "qualifications": [
                0,
                1,
                5,
                6
            ]
        },
        {
            "name": "Alex Cruz",
            "city": 0,
            "color": "blue",
            "qualifications": [
                2,
                7,
                0,
                4
            ]
        },
        {
            "name": "Mary Vega",
            "city": 0,
            "color": "blue",
            "qualifications": [
                7,
                8,
                6,
                2
            ]
        },
        {
            "name": "Jamie Hurst",
            "city": 1,
            "color": "blue",
            "qualifications": [
                5,
                2,
                5,
                1
            ]
        },
        {
            "name": "Jeremy Salinas",
            "city": 0,
            "color": "blue",
            "qualifications": [
                3,
                2,
                7,
                5
            ]
        },
        {
            "name": "Carol Dean",
            "city": 1,
            "color": "orange",
            "qualifications": [
                1,
                2,
                4,
                8
            ]
        },
        {
            "name": "Ronald Stewart",
            "city": 0,
            "color": "blue",
            "qualifications": [
                3,
                5,
                4,
                6
            ]
        },
        {
            "name": "Anna Meyers",
            "city": 1,
            "color": "orange",
            "qualifications": [
                0,
                6,
                7,
                6
            ]
        },
        {
            "name": "Ashley Jackson",
            "city": 0,
            "color": "blue",
            "qualifications": [
                6,
                9,
                3,
                9
            ]
        },
        {
            "name": "Regina Patel",
            "city": 0,
            "color": "blue",
            "qualifications": [
                6,
                9,
                8,
                9
            ]
        },
        {
            "name": "Timothy Thomas",
            "city": 0,
            "color": "blue",
            "qualifications": [
                9,
                2,
                8,
                4
            ]
        },
        {
            "name": "Nathan Blake",
            "city": 0,
            "color": "blue",
            "qualifications": [
                2,
                8,
                8,
                7
            ]
        },
        {
            "name": "Mark Parrish",
            "city": 0,
            "color": "blue",
            "qualifications": [
                7,
                5,
                7,
                1
            ]
        },
        {
            "name": "Christina Lucas",
            "city": 0,
            "color": "blue",
            "qualifications": [
                6,
                8,
                9,
                6
            ]
        },
        {
            "name": "Preston Fuller",
            "city": 0,
            "color": "blue",
            "qualifications": [
                7,
                9,
                7,
                9
            ]
        },
        {
            "name": "Sharon Chen",
            "city": 1,
            "color": "orange",
            "qualifications": [
                3,
                5,
                3,
                8
            ]
        },
        {
            "name": "Hector Macdonald",
            "city": 1,
            "color": "orange",
            "qualifications": [
                8,
                2,
                5,
                1
            ]
        },
        {
            "name": "Amber Walker",
            "city": 1,
            "color": "orange",
            "qualifications": [
                9,
                1,
                1,
                5
            ]
        },
        {
            "name": "Madison White",
            "city": 1,
            "color": "orange",
            "qualifications": [
                8,
                6,
                7,
                9
            ]
        },
        {
            "name": "Danny Smith",
            "city": 0,
            "color": "blue",
            "qualifications": [
                3,
                2,
                3,
                6
            ]
        },
        {
            "name": "Steven Martinez",
            "city": 0,
            "color": "blue",
            "qualifications": [
                7,
                1,
                8,
                7
            ]
        },
        {
            "name": "Misty Roberts",
            "city": 1,
            "color": "blue",
            "qualifications": [
                1,
                6,
                7,
                3
            ]
        },
        {
            "name": "Ian Gonzales",
            "city": 1,
            "color": "orange",
            "qualifications": [
                3,
                6,
                1,
                1
            ]
        },
        {
            "name": "Nicholas Andrews",
            "city": 1,
            "color": "orange",
            "qualifications": [
                8,
                7,
                4,
                5
            ]
        },
        {
            "name": "Deborah Brewer",
            "city": 1,
            "color": "orange",
            "qualifications": [
                5,
                4,
                9,
                7
            ]
        },
        {
            "name": "Daniel Williams",
            "city": 0,
            "color": "blue",
            "qualifications": [
                6,
                7,
                8,
                4
            ]
        },
        {
            "name": "Evan Henry",
            "city": 0,
            "color": "blue",
            "qualifications": [
                6,
                0,
                7,
                2
            ]
        },
        {
            "name": "Jessica Mendoza",
            "city": 1,
            "color": "orange",
            "qualifications": [
                3,
                8,
                2,
                1
            ]
        },
        {
            "name": "Mark Rodriguez",
            "city": 0,
            "color": "blue",
            "qualifications": [
                4,
                0,
                3,
                2
            ]
        },
        {
            "name": "Brandon Clark",
            "city": 0,
            "color": "blue",
            "qualifications": [
                1,
                3,
                7,
                3
            ]
        },
        {
            "name": "Lisa Valdez",
            "city": 0,
            "color": "blue",
            "qualifications": [
                9,
                4,
                3,
                9
            ]
        },
        {
            "name": "Tammy Mason",
            "city": 1,
            "color": "orange",
            "qualifications": [
                1,
                3,
                5,
                0
            ]
        },
        {
            "name": "Tiffany Cruz",
            "city": 1,
            "color": "orange",
            "qualifications": [
                8,
                6,
                4,
                7
            ]
        },
        {
            "name": "Tiffany Nichols",
            "city": 0,
            "color": "blue",
            "qualifications": [
                2,
                2,
                2,
                9
            ]
        },
        {
            "name": "Robert Cooper",
            "city": 0,
            "color": "blue",
            "qualifications": [
                7,
                5,
                8,
                7
            ]
        },
        {
            "name": "James Daniels",
            "city": 0,
            "color": "blue",
            "qualifications": [
                8,
                4,
                3,
                0
            ]
        },
        {
            "name": "Pamela Lopez",
            "city": 1,
            "color": "orange",
            "qualifications": [
                1,
                6,
                8,
                1
            ]
        },
        {
            "name": "Terry Newman",
            "city": 0,
            "color": "blue",
            "qualifications": [
                5,
                0,
                1,
                1
            ]
        },
        {
            "name": "Mariah Krause",
            "city": 0,
            "color": "blue",
            "qualifications": [
                3,
                8,
                4,
                3
            ]
        },
        {
            "name": "Elizabeth Lee",
            "city": 1,
            "color": "orange",
            "qualifications": [
                5,
                7,
                7,
                0
            ]
        },
        {
            "name": "Gregory Weaver",
            "city": 0,
            "color": "blue",
            "qualifications": [
                6,
                9,
                8,
                5
            ]
        },
        {
            "name": "Jessica Barber",
            "city": 0,
            "color": "blue",
            "qualifications": [
                4,
                6,
                6,
                8
            ]
        },
        {
            "name": "Nicole Sims",
            "city": 1,
            "color": "orange",
            "qualifications": [
                6,
                2,
                7,
                9
            ]
        },
        {
            "name": "Sarah Butler",
            "city": 1,
            "color": "orange",
            "qualifications": [
                9,
                0,
                9,
                8
            ]
        },
        {
            "name": "Taylor Gibbs",
            "city": 0,
            "color": "blue",
            "qualifications": [
                4,
                4,
                7,
                4
            ]
        },
        {
            "name": "Danny Barrera",
            "city": 1,
            "color": "orange",
            "qualifications": [
                2,
                1,
                8,
                7
            ]
        },
        {
            "name": "James Anderson",
            "city": 1,
            "color": "orange",
            "qualifications": [
                3,
                8,
                4,
                6
            ]
        },
        {
            "name": "Joshua Cooper",
            "city": 0,
            "color": "blue",
            "qualifications": [
                0,
                2,
                3,
                4
            ]
        },
        {
            "name": "Sharon Sampson",
            "city": 0,
            "color": "blue",
            "qualifications": [
                2,
                7,
                7,
                2
            ]
        },
        {
            "name": "Kimberly Hall",
            "city": 0,
            "color": "blue",
            "qualifications": [
                8,
                0,
                2,
                3
            ]
        },
        {
            "name": "Stephanie Mcguire",
            "city": 1,
            "color": "orange",
            "qualifications": [
                4,
                6,
                3,
                3
            ]
        },
        {
            "name": "Julie Mclaughlin",
            "city": 1,
            "color": "orange",
            "qualifications": [
                8,
                6,
                6,
                7
            ]
        },
        {
            "name": "Stephen Henderson",
            "city": 1,
            "color": "orange",
            "qualifications": [
                7,
                3,
                9,
                9
            ]
        },
        {
            "name": "Victor Braun",
            "city": 1,
            "color": "blue",
            "qualifications": [
                4,
                4,
                3,
                6
            ]
        },
        {
            "name": "Emily Smith",
            "city": 1,
            "color": "orange",
            "qualifications": [
                6,
                3,
                9,
                5
            ]
        },
        {
            "name": "Natalie Hernandez",
            "city": 1,
            "color": "orange",
            "qualifications": [
                9,
                9,
                8,
                4
            ]
        },
        {
            "name": "Alan Mcdonald",
            "city": 0,
            "color": "blue",
            "qualifications": [
                9,
                5,
                9,
                4
            ]
        },
        {
            "name": "Daniel Clark",
            "city": 1,
            "color": "orange",
            "qualifications": [
                6,
                3,
                1,
                5
            ]
        },
        {
            "name": "Jonathon Gonzalez",
            "city": 1,
            "color": "orange",
            "qualifications": [
                2,
                4,
                1,
                7
            ]
        },
        {
            "name": "Scott Brown",
            "city": 1,
            "color": "orange",
            "qualifications": [
                7,
                9,
                9,
                0
            ]
        },
        {
            "name": "Patricia Howard",
            "city": 1,
            "color": "orange",
            "qualifications": [
                8,
                9,
                3,
                1
            ]
        },
        {
            "name": "Gregory Smith",
            "city": 1,
            "color": "orange",
            "qualifications": [
                5,
                2,
                6,
                3
            ]
        },
        {
            "name": "Holly Brown",
            "city": 0,
            "color": "blue",
            "qualifications": [
                2,
                1,
                6,
                8
            ]
        },
        {
            "name": "Amy Lindsey",
            "city": 1,
            "color": "orange",
            "qualifications": [
                8,
                0,
                0,
                9
            ]
        },
        {
            "name": "Evan Sanders",
            "city": 1,
            "color": "orange",
            "qualifications": [
                6,
                5,
                0,
                6
            ]
        },
        {
            "name": "Steven Carlson",
            "city": 1,
            "color": "orange",
            "qualifications": [
                4,
                5,
                5,
                0
            ]
        },
        {
            "name": "Terri Daniels",
            "city": 1,
            "color": "orange",
            "qualifications": [
                6,
                4,
                2,
                8
            ]
        },
        {
            "name": "Samuel Smith",
            "city": 0,
            "color": "blue",
            "qualifications": [
                8,
                0,
                0,
                2
            ]
        },
        {
            "name": "Gabriel Lopez",
            "city": 1,
            "color": "orange",
            "qualifications": [
                7,
                4,
                1,
                9
            ]
        },
        {
            "name": "Melissa Peterson",
            "city": 0,
            "color": "blue",
            "qualifications": [
                0,
                7,
                1,
                2
            ]
        },
        {
            "name": "Alexander Hernandez",
            "city": 0,
            "color": "blue",
            "qualifications": [
                4,
                8,
                0,
                3
            ]
        },
        {
            "name": "Frederick Williams",
            "city": 0,
            "color": "blue",
            "qualifications": [
                0,
                7,
                0,
                0
            ]
        },
        {
            "name": "Rachael Johnson",
            "city": 0,
            "color": "blue",
            "qualifications": [
                9,
                5,
                8,
                0
            ]
        },
        {
            "name": "Derrick Kennedy",
            "city": 1,
            "color": "blue",
            "qualifications": [
                5,
                3,
                1,
                9
            ]
        },
        {
            "name": "Matthew Park",
            "city": 1,
            "color": "orange",
            "qualifications": [
                7,
                6,
                7,
                9
            ]
        },
        {
            "name": "Brenda Baker",
            "city": 1,
            "color": "orange",
            "qualifications": [
                7,
                4,
                4,
                7
            ]
        },
        {
            "name": "Richard Mullins",
            "city": 1,
            "color": "orange",
            "qualifications": [
                1,
                8,
                2,
                5
            ]
        },
        {
            "name": "Scott Rogers",
            "city": 0,
            "color": "blue",
            "qualifications": [
                7,
                5,
                2,
                4
            ]
        },
        {
            "name": "Bryan Petersen",
            "city": 1,
            "color": "orange",
            "qualifications": [
                4,
                2,
                9,
                6
            ]
        },
        {
            "name": "Oscar Mccoy",
            "city": 1,
            "color": "orange",
            "qualifications": [
                0,
                2,
                8,
                8
            ]
        },
        {
            "name": "Brandon Silva",
            "city": 0,
            "color": "blue",
            "qualifications": [
                3,
                9,
                1,
                4
            ]
        },
        {
            "name": "Teresa Smith",
            "city": 0,
            "color": "blue",
            "qualifications": [
                5,
                9,
                9,
                2
            ]
        },
        {
            "name": "Holly Boyd",
            "city": 0,
            "color": "blue",
            "qualifications": [
                6,
                8,
                2,
                1
            ]
        },
        {
            "name": "Marie Terry",
            "city": 0,
            "color": "blue",
            "qualifications": [
                8,
                7,
                9,
                8
            ]
        },
        {
            "name": "David Butler",
            "city": 1,
            "color": "orange",
            "qualifications": [
                9,
                7,
                7,
                1
            ]
        },
        {
            "name": "Ronnie Koch",
            "city": 1,
            "color": "orange",
            "qualifications": [
                4,
                1,
                3,
                7
            ]
        },
        {
            "name": "Tara Crawford",
            "city": 1,
            "color": "orange",
            "qualifications": [
                1,
                6,
                0,
                8
            ]
        },
        {
            "name": "Joshua Greer",
            "city": 0,
            "color": "blue",
            "qualifications": [
                8,
                3,
                2,
                0
            ]
        },
        {
            "name": "James Tate",
            "city": 1,
            "color": "orange",
            "qualifications": [
                2,
                0,
                7,
                0
            ]
        },
        {
            "name": "Miranda Gray",
            "city": 1,
            "color": "blue",
            "qualifications": [
                4,
                6,
                2,
                3
            ]
        },
        {
            "name": "Jennifer Fitzgerald",
            "city": 1,
            "color": "orange",
            "qualifications": [
                0,
                7,
                1,
                8
            ]
        },
        {
            "name": "Kimberly Hester",
            "city": 1,
            "color": "orange",
            "qualifications": [
                5,
                9,
                4,
                7
            ]
        },
        {
            "name": "Nicole Mitchell",
            "city": 1,
            "color": "orange",
            "qualifications": [
                3,
                1,
                8,
                7
            ]
        },
        {
            "name": "Laura Price",
            "city": 0,
            "color": "blue",
            "qualifications": [
                3,
                1,
                2,
                5
            ]
        },
        {
            "name": "Christy Hart",
            "city": 1,
            "color": "orange",
            "qualifications": [
                7,
                6,
                7,
                9
            ]
        },
        {
            "name": "Erika Gonzalez",
            "city": 0,
            "color": "blue",
            "qualifications": [
                4,
                9,
                5,
                1
            ]
        },
        {
            "name": "Eric Webster",
            "city": 0,
            "color": "blue",
            "qualifications": [
                0,
                6,
                5,
                3
            ]
        },
        {
            "name": "Ebony Turner",
            "city": 1,
            "color": "orange",
            "qualifications": [
                9,
                8,
                0,
                6
            ]
        },
        {
            "name": "John Johnson",
            "city": 1,
            "color": "orange",
            "qualifications": [
                2,
                6,
                6,
                2
            ]
        },
        {
            "name": "David Lee",
            "city": 0,
            "color": "blue",
            "qualifications": [
                1,
                5,
                7,
                9
            ]
        },
        {
            "name": "William Hernandez",
            "city": 0,
            "color": "blue",
            "qualifications": [
                1,
                7,
                6,
                1
            ]
        },
        {
            "name": "Philip Smith",
            "city": 1,
            "color": "orange",
            "qualifications": [
                5,
                4,
                4,
                0
            ]
        },
        {
            "name": "John Wang",
            "city": 1,
            "color": "orange",
            "qualifications": [
                3,
                0,
                1,
                6
            ]
        },
        {
            "name": "Christine Santos",
            "city": 1,
            "color": "orange",
            "qualifications": [
                2,
                9,
                0,
                6
            ]
        },
        {
            "name": "Jennifer Andrews",
            "city": 1,
            "color": "orange",
            "qualifications": [
                6,
                5,
                9,
                1
            ]
        },
        {
            "name": "Jamie Tanner",
            "city": 1,
            "color": "orange",
            "qualifications": [
                3,
                6,
                2,
                4
            ]
        },
        {
            "name": "Paul Combs",
            "city": 1,
            "color": "blue",
            "qualifications": [
                5,
                4,
                9,
                8
            ]
        },
        {
            "name": "Patricia Delacruz",
            "city": 1,
            "color": "orange",
            "qualifications": [
                0,
                9,
                8,
                5
            ]
        },
        {
            "name": "Robert Jimenez",
            "city": 1,
            "color": "orange",
            "qualifications": [
                5,
                0,
                9,
                0
            ]
        },
        {
            "name": "Edward Weaver",
            "city": 0,
            "color": "blue",
            "qualifications": [
                2,
                1,
                9,
                3
            ]
        },
        {
            "name": "Joel Harris MD",
            "city": 1,
            "color": "orange",
            "qualifications": [
                4,
                3,
                7,
                8
            ]
        },
        {
            "name": "Mathew Martin",
            "city": 1,
            "color": "orange",
            "qualifications": [
                0,
                3,
                4,
                9
            ]
        },
        {
            "name": "Doris Taylor",
            "city": 0,
            "color": "blue",
            "qualifications": [
                2,
                4,
                1,
                4
            ]
        },
        {
            "name": "Mark Macdonald",
            "city": 0,
            "color": "blue",
            "qualifications": [
                5,
                0,
                0,
                0
            ]
        },
        {
            "name": "Kelly Page",
            "city": 1,
            "color": "blue",
            "qualifications": [
                4,
                2,
                9,
                1
            ]
        },
        {
            "name": "Russell Williams DDS",
            "city": 1,
            "color": "orange",
            "qualifications": [
                5,
                2,
                0,
                3
            ]
        },
        {
            "name": "Joseph Reynolds",
            "city": 1,
            "color": "orange",
            "qualifications": [
                6,
                0,
                4,
                0
            ]
        },
        {
            "name": "Sonya Goodman",
            "city": 0,
            "color": "blue",
            "qualifications": [
                1,
                1,
                6,
                4
            ]
        },
        {
            "name": "James Carter",
            "city": 1,
            "color": "orange",
            "qualifications": [
                8,
                1,
                6,
                6
            ]
        },
        {
            "name": "Matthew Garcia",
            "city": 0,
            "color": "blue",
            "qualifications": [
                0,
                1,
                9,
                1
            ]
        },
        {
            "name": "Regina Craig",
            "city": 1,
            "color": "orange",
            "qualifications": [
                7,
                5,
                8,
                5
            ]
        },
        {
            "name": "Kimberly Coleman",
            "city": 1,
            "color": "orange",
            "qualifications": [
                4,
                0,
                3,
                0
            ]
        },
        {
            "name": "Robert Matthews",
            "city": 1,
            "color": "orange",
            "qualifications": [
                8,
                3,
                1,
                7
            ]
        },
        {
            "name": "Amy Bryant",
            "city": 1,
            "color": "orange",
            "qualifications": [
                4,
                0,
                6,
                9
            ]
        },
        {
            "name": "Karen King",
            "city": 1,
            "color": "orange",
            "qualifications": [
                4,
                6,
                8,
                8
            ]
        },
        {
            "name": "Cheryl Dunn",
            "city": 0,
            "color": "blue",
            "qualifications": [
                4,
                5,
                5,
                6
            ]
        },
        {
            "name": "Alejandra Johnson",
            "city": 0,
            "color": "orange",
            "qualifications": [
                2,
                1,
                9,
                8
            ]
        },
        {
            "name": "Brooke Grant",
            "city": 1,
            "color": "orange",
            "qualifications": [
                4,
                3,
                6,
                0
            ]
        },
        {
            "name": "Ann Parker",
            "city": 0,
            "color": "orange",
            "qualifications": [
                9,
                9,
                2,
                7
            ]
        },
        {
            "name": "Charles Reed",
            "city": 0,
            "color": "blue",
            "qualifications": [
                9,
                7,
                8,
                7
            ]
        },
        {
            "name": "Curtis Ramsey",
            "city": 1,
            "color": "orange",
            "qualifications": [
                8,
                3,
                3,
                3
            ]
        },
        {
            "name": "Daniel Gonzalez",
            "city": 1,
            "color": "orange",
            "qualifications": [
                3,
                4,
                2,
                9
            ]
        },
        {
            "name": "Martha Salazar",
            "city": 1,
            "color": "orange",
            "qualifications": [
                7,
                6,
                5,
                6
            ]
        },
        {
            "name": "James Edwards",
            "city": 1,
            "color": "orange",
            "qualifications": [
                5,
                7,
                4,
                8
            ]
        },
        {
            "name": "Jennifer Harris",
            "city": 0,
            "color": "blue",
            "qualifications": [
                9,
                4,
                2,
                5
            ]
        },
        {
            "name": "Tristan Roberts",
            "city": 1,
            "color": "orange",
            "qualifications": [
                0,
                8,
                9,
                2
            ]
        },
        {
            "name": "Aaron Stephens",
            "city": 1,
            "color": "orange",
            "qualifications": [
                2,
                9,
                6,
                2
            ]
        },
        {
            "name": "Mr. Todd Warren",
            "city": 1,
            "color": "orange",
            "qualifications": [
                0,
                0,
                0,
                0
            ]
        },
        {
            "name": "Heather Nunez",
            "city": 1,
            "color": "orange",
            "qualifications": [
                2,
                6,
                3,
                1
            ]
        },
        {
            "name": "Sean Allen",
            "city": 0,
            "color": "blue",
            "qualifications": [
                0,
                3,
                6,
                1
            ]
        },
        {
            "name": "David Bell",
            "city": 1,
            "color": "orange",
            "qualifications": [
                9,
                8,
                9,
                3
            ]
        },
        {
            "name": "Mark Rodriguez",
            "city": 0,
            "color": "blue",
            "qualifications": [
                0,
                7,
                2,
                2
            ]
        },
        {
            "name": "Nicole Brennan",
            "city": 1,
            "color": "orange",
            "qualifications": [
                3,
                0,
                5,
                7
            ]
        },
        {
            "name": "Veronica Kim",
            "city": 1,
            "color": "orange",
            "qualifications": [
                3,
                1,
                1,
                4
            ]
        },
        {
            "name": "Deborah Carter",
            "city": 1,
            "color": "orange",
            "qualifications": [
                9,
                8,
                6,
                9
            ]
        },
        {
            "name": "Tanya Jacobs",
            "city": 1,
            "color": "orange",
            "qualifications": [
                2,
                0,
                8,
                6
            ]
        },
        {
            "name": "Jenna Mendez",
            "city": 1,
            "color": "orange",
            "qualifications": [
                7,
                0,
                7,
                3
            ]
        },
        {
            "name": "Karen Warren",
            "city": 1,
            "color": "orange",
            "qualifications": [
                3,
                5,
                0,
                3
            ]
        },
        {
            "name": "Emily Gordon",
            "city": 1,
            "color": "orange",
            "qualifications": [
                8,
                9,
                4,
                1
            ]
        },
        {
            "name": "Erin Allen",
            "city": 0,
            "color": "blue",
            "qualifications": [
                4,
                1,
                2,
                2
            ]
        },
        {
            "name": "Janet Baker",
            "city": 1,
            "color": "orange",
            "qualifications": [
                7,
                9,
                8,
                1
            ]
        },
        {
            "name": "Matthew Nguyen",
            "city": 0,
            "color": "blue",
            "qualifications": [
                9,
                2,
                5,
                7
            ]
        },
        {
            "name": "Vincent Vargas",
            "city": 1,
            "color": "orange",
            "qualifications": [
                2,
                3,
                6,
                5
            ]
        },
        {
            "name": "Shelby Wilson",
            "city": 0,
            "color": "blue",
            "qualifications": [
                5,
                2,
                2,
                9
            ]
        },
        {
            "name": "Dean Kennedy",
            "city": 1,
            "color": "orange",
            "qualifications": [
                1,
                0,
                5,
                9
            ]
        },
        {
            "name": "Troy Sims",
            "city": 0,
            "color": "blue",
            "qualifications": [
                9,
                1,
                3,
                4
            ]
        },
        {
            "name": "Jerry Miller",
            "city": 1,
            "color": "orange",
            "qualifications": [
                4,
                6,
                6,
                7
            ]
        },
        {
            "name": "Ms. Crystal Wilson MD",
            "city": 1,
            "color": "orange",
            "qualifications": [
                0,
                3,
                2,
                8
            ]
        },
        {
            "name": "Benjamin Powell",
            "city": 0,
            "color": "blue",
            "qualifications": [
                7,
                9,
                7,
                7
            ]
        },
        {
            "name": "Michael Robinson",
            "city": 1,
            "color": "orange",
            "qualifications": [
                5,
                8,
                7,
                2
            ]
        },
        {
            "name": "Brandon Carpenter",
            "city": 0,
            "color": "blue",
            "qualifications": [
                7,
                6,
                5,
                5
            ]
        },
        {
            "name": "Derek Williams",
            "city": 1,
            "color": "orange",
            "qualifications": [
                7,
                6,
                8,
                1
            ]
        },
        {
            "name": "Mariah Lopez",
            "city": 1,
            "color": "orange",
            "qualifications": [
                7,
                4,
                1,
                5
            ]
        },
        {
            "name": "Raymond Douglas",
            "city": 1,
            "color": "orange",
            "qualifications": [
                9,
                0,
                7,
                7
            ]
        },
        {
            "name": "Dr. Peter Frost MD",
            "city": 1,
            "color": "orange",
            "qualifications": [
                4,
                1,
                2,
                2
            ]
        },
        {
            "name": "Suzanne Pace",
            "city": 0,
            "color": "blue",
            "qualifications": [
                2,
                9,
                0,
                7
            ]
        },
        {
            "name": "Robert Hays",
            "city": 0,
            "color": "blue",
            "qualifications": [
                3,
                2,
                8,
                6
            ]
        },
        {
            "name": "Patrick Leonard",
            "city": 0,
            "color": "blue",
            "qualifications": [
                8,
                1,
                4,
                0
            ]
        },
        {
            "name": "Ryan Montes",
            "city": 1,
            "color": "orange",
            "qualifications": [
                1,
                1,
                8,
                2
            ]
        },
        {
            "name": "Kylie Robles",
            "city": 0,
            "color": "blue",
            "qualifications": [
                1,
                9,
                8,
                2
            ]
        },
        {
            "name": "Amanda Bowen",
            "city": 1,
            "color": "orange",
            "qualifications": [
                5,
                6,
                5,
                9
            ]
        },
        {
            "name": "Margaret Thomas",
            "city": 0,
            "color": "blue",
            "qualifications": [
                7,
                9,
                3,
                1
            ]
        },
        {
            "name": "Sonia Wang",
            "city": 1,
            "color": "orange",
            "qualifications": [
                3,
                4,
                5,
                9
            ]
        },
        {
            "name": "Oscar Smith",
            "city": 0,
            "color": "blue",
            "qualifications": [
                0,
                7,
                5,
                1
            ]
        },
        {
            "name": "Douglas Mendez",
            "city": 1,
            "color": "orange",
            "qualifications": [
                9,
                1,
                6,
                2
            ]
        },
        {
            "name": "Amy Boone",
            "city": 1,
            "color": "orange",
            "qualifications": [
                1,
                2,
                9,
                8
            ]
        },
        {
            "name": "Paul Castro",
            "city": 0,
            "color": "blue",
            "qualifications": [
                3,
                4,
                0,
                8
            ]
        },
        {
            "name": "Joshua Davis",
            "city": 1,
            "color": "orange",
            "qualifications": [
                1,
                2,
                8,
                9
            ]
        },
        {
            "name": "Courtney Hopkins",
            "city": 1,
            "color": "orange",
            "qualifications": [
                8,
                2,
                7,
                2
            ]
        },
        {
            "name": "William Hughes",
            "city": 1,
            "color": "orange",
            "qualifications": [
                5,
                7,
                0,
                4
            ]
        },
        {
            "name": "Megan Obrien",
            "city": 0,
            "color": "blue",
            "qualifications": [
                6,
                8,
                9,
                3
            ]
        },
        {
            "name": "Leonard Oliver",
            "city": 1,
            "color": "orange",
            "qualifications": [
                5,
                3,
                2,
                9
            ]
        },
        {
            "name": "Eric Koch",
            "city": 0,
            "color": "blue",
            "qualifications": [
                7,
                4,
                4,
                1
            ]
        },
        {
            "name": "Vanessa Moore",
            "city": 1,
            "color": "orange",
            "qualifications": [
                9,
                8,
                1,
                6
            ]
        },
        {
            "name": "Jaime Ballard",
            "city": 1,
            "color": "orange",
            "qualifications": [
                2,
                2,
                0,
                6
            ]
        },
        {
            "name": "Barry Smith",
            "city": 0,
            "color": "blue",
            "qualifications": [
                2,
                6,
                1,
                2
            ]
        },
        {
            "name": "Joshua Mooney",
            "city": 1,
            "color": "orange",
            "qualifications": [
                0,
                6,
                2,
                9
            ]
        },
        {
            "name": "Joanna Robertson",
            "city": 1,
            "color": "orange",
            "qualifications": [
                1,
                0,
                3,
                5
            ]
        },
        {
            "name": "Brittany Raymond",
            "city": 0,
            "color": "orange",
            "qualifications": [
                3,
                6,
                7,
                1
            ]
        },
        {
            "name": "Darius Mcintosh",
            "city": 1,
            "color": "orange",
            "qualifications": [
                5,
                3,
                9,
                1
            ]
        },
        {
            "name": "Anthony Burton",
            "city": 0,
            "color": "blue",
            "qualifications": [
                1,
                2,
                9,
                9
            ]
        },
        {
            "name": "Renee Conley",
            "city": 0,
            "color": "blue",
            "qualifications": [
                4,
                1,
                1,
                5
            ]
        },
        {
            "name": "Jim Armstrong",
            "city": 1,
            "color": "orange",
            "qualifications": [
                2,
                9,
                0,
                4
            ]
        },
        {
            "name": "Steven Mcintosh",
            "city": 1,
            "color": "orange",
            "qualifications": [
                1,
                7,
                7,
                4
            ]
        },
        {
            "name": "Adrian Weber",
            "city": 0,
            "color": "blue",
            "qualifications": [
                9,
                8,
                6,
                8
            ]
        },
        {
            "name": "Bradley Gonzalez",
            "city": 1,
            "color": "orange",
            "qualifications": [
                4,
                7,
                8,
                4
            ]
        },
        {
            "name": "Michael Mason",
            "city": 0,
            "color": "blue",
            "qualifications": [
                3,
                0,
                0,
                4
            ]
        },
        {
            "name": "Susan Johnson",
            "city": 0,
            "color": "blue",
            "qualifications": [
                0,
                5,
                4,
                9
            ]
        },
        {
            "name": "John Clark",
            "city": 0,
            "color": "blue",
            "qualifications": [
                5,
                6,
                2,
                3
            ]
        },
        {
            "name": "Mary Padilla",
            "city": 0,
            "color": "blue",
            "qualifications": [
                2,
                9,
                8,
                1
            ]
        },
        {
            "name": "Allison Owens",
            "city": 0,
            "color": "blue",
            "qualifications": [
                2,
                3,
                9,
                2
            ]
        },
        {
            "name": "Steven Cummings",
            "city": 0,
            "color": "blue",
            "qualifications": [
                4,
                0,
                6,
                6
            ]
        },
        {
            "name": "Keith Romero",
            "city": 0,
            "color": "blue",
            "qualifications": [
                9,
                9,
                1,
                4
            ]
        },
        {
            "name": "Brent Mccoy",
            "city": 0,
            "color": "blue",
            "qualifications": [
                2,
                6,
                2,
                5
            ]
        },
        {
            "name": "Stacey Johnson",
            "city": 0,
            "color": "blue",
            "qualifications": [
                0,
                8,
                8,
                7
            ]
        },
        {
            "name": "Jordan Young",
            "city": 0,
            "color": "blue",
            "qualifications": [
                5,
                8,
                8,
                1
            ]
        },
        {
            "name": "Noah Morrow",
            "city": 0,
            "color": "blue",
            "qualifications": [
                9,
                7,
                4,
                6
            ]
        },
        {
            "name": "Andrea Thompson",
            "city": 1,
            "color": "orange",
            "qualifications": [
                1,
                6,
                0,
                3
            ]
        },
        {
            "name": "Janet Foster",
            "city": 0,
            "color": "blue",
            "qualifications": [
                3,
                6,
                8,
                5
            ]
        },
        {
            "name": "Todd Johnston",
            "city": 0,
            "color": "blue",
            "qualifications": [
                9,
                3,
                8,
                8
            ]
        },
        {
            "name": "Victoria Carney",
            "city": 1,
            "color": "orange",
            "qualifications": [
                7,
                0,
                5,
                6
            ]
        },
        {
            "name": "John Hester",
            "city": 0,
            "color": "blue",
            "qualifications": [
                8,
                7,
                5,
                0
            ]
        },
        {
            "name": "Lindsay Le",
            "city": 0,
            "color": "blue",
            "qualifications": [
                6,
                1,
                5,
                9
            ]
        },
        {
            "name": "Jessica Flores",
            "city": 1,
            "color": "orange",
            "qualifications": [
                6,
                9,
                0,
                6
            ]
        },
        {
            "name": "Danielle Sims",
            "city": 0,
            "color": "blue",
            "qualifications": [
                7,
                8,
                2,
                2
            ]
        },
        {
            "name": "Emily Miller",
            "city": 0,
            "color": "blue",
            "qualifications": [
                1,
                9,
                0,
                4
            ]
        },
        {
            "name": "Jennifer Ruiz",
            "city": 0,
            "color": "blue",
            "qualifications": [
                5,
                3,
                4,
                0
            ]
        },
        {
            "name": "Bianca Smith",
            "city": 1,
            "color": "orange",
            "qualifications": [
                3,
                6,
                0,
                4
            ]
        },
        {
            "name": "Michael Zimmerman DDS",
            "city": 0,
            "color": "blue",
            "qualifications": [
                4,
                6,
                0,
                1
            ]
        },
        {
            "name": "Michael Buchanan",
            "city": 0,
            "color": "blue",
            "qualifications": [
                5,
                0,
                8,
                2
            ]
        },
        {
            "name": "Michael Oneill",
            "city": 1,
            "color": "orange",
            "qualifications": [
                5,
                8,
                6,
                9
            ]
        },
        {
            "name": "Anita Cherry",
            "city": 0,
            "color": "blue",
            "qualifications": [
                3,
                7,
                6,
                9
            ]
        },
        {
            "name": "David Morris",
            "city": 1,
            "color": "orange",
            "qualifications": [
                8,
                3,
                4,
                2
            ]
        },
        {
            "name": "James Leblanc",
            "city": 0,
            "color": "blue",
            "qualifications": [
                9,
                1,
                1,
                7
            ]
        },
        {
            "name": "Tracy Evans",
            "city": 0,
            "color": "blue",
            "qualifications": [
                0,
                7,
                7,
                1
            ]
        },
        {
            "name": "Teresa Fox",
            "city": 0,
            "color": "blue",
            "qualifications": [
                4,
                5,
                3,
                5
            ]
        },
        {
            "name": "Toni Brown",
            "city": 1,
            "color": "orange",
            "qualifications": [
                1,
                3,
                8,
                2
            ]
        },
        {
            "name": "Ashley Duncan",
            "city": 0,
            "color": "blue",
            "qualifications": [
                9,
                1,
                8,
                5
            ]
        },
        {
            "name": "Jerry Mitchell",
            "city": 0,
            "color": "blue",
            "qualifications": [
                6,
                2,
                7,
                0
            ]
        },
        {
            "name": "Thomas Callahan",
            "city": 0,
            "color": "blue",
            "qualifications": [
                0,
                2,
                9,
                2
            ]
        },
        {
            "name": "Timothy Burgess",
            "city": 0,
            "color": "blue",
            "qualifications": [
                8,
                1,
                2,
                7
            ]
        },
        {
            "name": "Adam West",
            "city": 0,
            "color": "blue",
            "qualifications": [
                3,
                3,
                1,
                0
            ]
        },
        {
            "name": "Marc Burton",
            "city": 1,
            "color": "orange",
            "qualifications": [
                0,
                7,
                9,
                5
            ]
        },
        {
            "name": "Gerald Lopez",
            "city": 0,
            "color": "blue",
            "qualifications": [
                5,
                7,
                7,
                8
            ]
        },
        {
            "name": "Michelle Hernandez",
            "city": 1,
            "color": "orange",
            "qualifications": [
                6,
                3,
                4,
                2
            ]
        },
        {
            "name": "Clinton Goodwin",
            "city": 1,
            "color": "orange",
            "qualifications": [
                2,
                9,
                4,
                7
            ]
        },
        {
            "name": "Randy Franklin",
            "city": 1,
            "color": "orange",
            "qualifications": [
                6,
                5,
                0,
                5
            ]
        },
        {
            "name": "Karen Davis",
            "city": 1,
            "color": "orange",
            "qualifications": [
                3,
                8,
                0,
                6
            ]
        },
        {
            "name": "George Giles",
            "city": 0,
            "color": "blue",
            "qualifications": [
                7,
                5,
                2,
                3
            ]
        },
        {
            "name": "Lauren Walker",
            "city": 1,
            "color": "orange",
            "qualifications": [
                2,
                3,
                7,
                1
            ]
        },
        {
            "name": "Donald Smith",
            "city": 0,
            "color": "blue",
            "qualifications": [
                2,
                0,
                3,
                3
            ]
        },
        {
            "name": "Samantha Williams",
            "city": 1,
            "color": "orange",
            "qualifications": [
                5,
                1,
                3,
                8
            ]
        },
        {
            "name": "Charles David",
            "city": 0,
            "color": "blue",
            "qualifications": [
                9,
                6,
                9,
                5
            ]
        },
        {
            "name": "Lindsey Bailey",
            "city": 0,
            "color": "blue",
            "qualifications": [
                2,
                0,
                2,
                6
            ]
        },
        {
            "name": "Mark Jones",
            "city": 1,
            "color": "orange",
            "qualifications": [
                2,
                9,
                4,
                5
            ]
        },
        {
            "name": "Christopher Jones",
            "city": 1,
            "color": "orange",
            "qualifications": [
                0,
                4,
                9,
                3
            ]
        },
        {
            "name": "Joshua Gibbs",
            "city": 0,
            "color": "blue",
            "qualifications": [
                6,
                7,
                2,
                3
            ]
        },
        {
            "name": "Michael Wiggins",
            "city": 0,
            "color": "blue",
            "qualifications": [
                3,
                8,
                0,
                7
            ]
        },
        {
            "name": "Jennifer Jones",
            "city": 1,
            "color": "orange",
            "qualifications": [
                9,
                0,
                7,
                6
            ]
        },
        {
            "name": "Seth Garrett",
            "city": 1,
            "color": "orange",
            "qualifications": [
                3,
                6,
                1,
                4
            ]
        },
        {
            "name": "Daniel Gonzalez",
            "city": 0,
            "color": "blue",
            "qualifications": [
                9,
                5,
                6,
                6
            ]
        },
        {
            "name": "Catherine Clark",
            "city": 0,
            "color": "blue",
            "qualifications": [
                2,
                1,
                7,
                5
            ]
        },
        {
            "name": "Brian Ray",
            "city": 1,
            "color": "orange",
            "qualifications": [
                2,
                8,
                2,
                6
            ]
        },
        {
            "name": "Susan Friedman",
            "city": 1,
            "color": "orange",
            "qualifications": [
                0,
                5,
                7,
                4
            ]
        },
        {
            "name": "Michael Schmidt",
            "city": 1,
            "color": "orange",
            "qualifications": [
                5,
                5,
                6,
                6
            ]
        },
        {
            "name": "Teresa Cole",
            "city": 0,
            "color": "blue",
            "qualifications": [
                2,
                6,
                6,
                7
            ]
        },
        {
            "name": "Kenneth Nash DDS",
            "city": 1,
            "color": "orange",
            "qualifications": [
                5,
                1,
                4,
                5
            ]
        }
    ]
}